<template>
<div v-if="serviceAccount">
    <v-snackbar :top="true" v-model="snackbar">
        {{text}}
        <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-snackbar :top="y === 'top'" v-model="errorSnackbar">
        {{text}}
        <v-btn color="red" class="white--text" flat @click="errorSnackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat dense color="white">
        <v-btn icon @click="routeToServiceAccount()">
            <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-chip small v-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&serviceAccount.isSuspended&&serviceAccount.isActive" class="white--text" color="orange">Suspended</v-chip>
        <v-chip small v-else-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)" class="white--text" color="light-green">Active</v-chip>
        <v-chip small v-else-if="serviceAccount.fnoActivationDate!==null&&serviceAccount.fnoDeactivationDate!=null&&(new Date(serviceAccount.fnoDeactivationDate)<new Date())" class="white--text" color="red">Inactive</v-chip>
        <v-chip small v-else-if="serviceAccount.fnoActivationDate==null||new Date(serviceAccount.fnoActivationDate)>new Date()" class="white--text" color="blue">Pending</v-chip>
        <v-toolbar-title>
            {{serviceAccount.circuitNumber}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="serviceAccount&&serviceAccount.device&&serviceAccount.deviceBridgeId&&serviceAccount.device.isU2000">
            <v-btn @click="suspendServices(serviceAccount)" round small class="white--text" color="red" v-if="allOpenTickets.filter(x=>x.ticketCategoryItem&&x.ticketCategoryItem.name === 'U2000: Deactivate Service').length==0&&serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)&&!serviceAccount.isSuspended">Suspend</v-btn>
            <v-btn @click="reactivateServices(serviceAccount)" round small class="white--text" color="light-green" v-else-if="allOpenTickets.filter(x=>x.ticketCategoryItem&&x.ticketCategoryItem.name === 'U2000: Activate Service').length==0&&serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&serviceAccount.isSuspended&&serviceAccount.isActive">Reactivate</v-btn>
            <!-- <v-chip v-else-if="serviceAccount.fnoActivationDate!==null&&serviceAccount.fnoDeactivationDate!=null&&(new Date(serviceAccount.fnoDeactivationDate)<new Date())" class="white--text" color="red">Inactive</v-chip> -->
        </div>

    </v-toolbar>
    <v-divider></v-divider>
    <v-layout justify-start wrap>
        <v-flex xs12 sm8>
            <v-layout justify-start wrap>
                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader>
                        <v-subheader style="background: #f0f0f0"> Network Operator</v-subheader>
                        <v-list-tile @click="goToLocation()">
                            <v-list-tile-action>
                                <v-icon v-if="serviceAccount.location">location_on</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{ serviceAccount.location.locationDescription }}
                                </v-list-tile-title>
                                <v-list-tile-subtitle style="fontSize: 14px">
                                    <span class="grey--text font-weight-light">{{
                serviceAccount.location.locationNetwork.name
              }}</span>
                                    <v-chip style="height: 18px" class="white--text" color="green" v-if="serviceAccount.location&&serviceAccount.location.locationNetwork.networkStatus=='Live'">Live</v-chip>
                                    <v-chip style="height: 18px" class="white--text" color="blue" v-if="serviceAccount.location&&serviceAccount.location.locationNetwork.networkStatus=='In Progress'">In Progress</v-chip>
                                    <v-chip style="height: 18px" class="white--text" color="orange" v-if="serviceAccount.location&&serviceAccount.location.locationNetwork.networkStatus=='Planned'">Planned</v-chip>
                                </v-list-tile-subtitle>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>bar_chart</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.packagesIsp.packagesFno.packageCode}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    <v-layout align-center justify-start style="fontSize: 14px">
                                        <v-icon style="height: 15px" color="light-green">arrow_drop_down</v-icon>
                                        {{serviceAccount.packagesIsp.packagesFno.speedProfile.downloadMbps}}
                                        <v-icon style="height: 15px" color="red">arrow_drop_up</v-icon>
                                        {{serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps}}
                                    </v-layout>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="fontSize: 14px">
                                {{serviceAccount.packagesIsp.packagesFno.packageBasePrice | currency}} pm
                                <small>excl. VAT</small>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-subheader style="background: #f0f0f0">Internet Service Provider</v-subheader>
                        <v-list-tile style="fontSize: 14px" @click="routeToIsp(serviceAccount.customerOrganisationId)">
                            <v-list-tile-avatar>
                                <v-img contain :src="serviceAccount.customerOrganisation.logo" />
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.customerOrganisation.name}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile style="fontSize: 14px">
                            <v-list-tile-action>
                                <v-icon>bar_chart</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.packagesIsp.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    {{serviceAccount.packagesIsp.term}} | {{serviceAccount.packagesIsp.onceOffPriceVatInc | currency}} Once-Off
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="fontSize: 14px">
                                {{serviceAccount.packagesIsp.recurringPriceVatInc | currency}} pm
                                <small>incl. VAT</small>
                            </v-list-tile-action>
                        </v-list-tile>
                       
                          <v-list-tile style="fontSize: 14px">
                            <v-list-tile-action>
                                <v-icon>event</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{formatDate(serviceAccount.fnoActivationDate)}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                  Initial Activation:  <span v-if="serviceAccount.initialActivation">{{formatDate(serviceAccount.initialActivation)}}</span><span v-else>{{formatDate(serviceAccount.fnoActivationDate)}}</span>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile style="fontSize: 14px" v-if="serviceAccount.authenticationType.toLowerCase() == 'pppoe'&&serviceAccount.pppoeUsername">
                            <v-list-tile-action>
                                <v-icon>router</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.pppoeUsername}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    {{serviceAccount.pppoePassword}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile style="fontSize: 14px" v-if="serviceAccount.contact">
                            <v-list-tile-action>
                                <v-icon>person</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.contact.name}} {{ serviceAccount.contact.surname }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 12px" v-if="serviceAccount.contact.mobileNumber">
                                   <v-icon small class="mr-2">phone</v-icon> {{formatMobileNumber(serviceAccount.contact.mobileNumber)}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-flex>
                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader three-line>
                        <v-subheader style="background: #f0f0f0"> Device</v-subheader>
                           <v-list-tile @click="redirectToDevice(serviceAccount.deviceId)">
                            <v-list-tile-action>
                                <v-icon>router</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.device.ponMac}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    {{serviceAccount.device.deviceMakeModel.deviceMake.name}} {{serviceAccount.device.deviceMakeModel.name}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    {{serviceAccount.device.systemName}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action :key="onuKey" v-if="deviceDetail.details">
                                <v-chip color="light-green" style="height: 18px" class="white--text" :key="onuKey" v-if="deviceDetail&&deviceDetail.status&&deviceDetail.status.isOnline">Online</v-chip>
                                <v-chip color="red" style="height: 18px" class="white--text" :key="onuKey" v-else-if="deviceDetail&&deviceDetail.status&&!deviceDetail.status.isOnline">Offline</v-chip>
                                <v-chip style="height: 18px" v-if="deviceDetail.details.OPTICSRXPOWER">Tx: {{parseFloat(deviceDetail.details.OPTICSRXPOWER)/100}} dBm</v-chip>
                                <v-chip style="height: 18px" v-if="deviceDetail.details.OPTICSTXPOWER">Rx: {{parseFloat(deviceDetail.details.OPTICSTXPOWER)/100}} dBm</v-chip>
                            </v-list-tile-action>
                            <v-list-tile-action :key="onuKey" v-else-if="deviceDetail.status">
                                <v-chip :key="onuKey" color="light-green" style="height: 18px" class="white--text" v-if="deviceDetail&&deviceDetail.status&&deviceDetail.status.isOnline">Online</v-chip>
                                <v-chip :key="onuKey" color="red" style="height: 18px" class="white--text" v-else-if="deviceDetail&&deviceDetail.status&&!deviceDetail.status.isOnline">Offline</v-chip>
                                <v-chip :key="onuKey" style="height: 18px" v-if="deviceDetail.status.rxPower">Rx Power: {{deviceDetail.status.rxPower}} dBm</v-chip>
                                <v-chip :key="onuKey" style="height: 18px" v-if="deviceDetail.status.opticRssi">Optic RSSI: {{deviceDetail.status.opticRssi}} dBm</v-chip>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                    <v-list subheader two-line>
                          <v-layout wrap v-if="deviceDetail&&deviceDetail.details">
                            <v-flex xs4>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>power</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">
                                            {{deviceDetail.details.OPTICSTXVOL}}mV
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs4>
                                  <v-list-tile :key="onuKey">
                            <v-list-tile-action>
                                <v-icon>straighten</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                   {{deviceDetail.details.ONTRANGING}} m
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                            </v-flex>
                            <v-flex xs4>
                                 <v-list-tile :key="onuKey" v-if="deviceDetail&&deviceDetail.details">
                            <v-list-tile-action>
                                <v-icon>thermostat</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                     {{deviceDetail.details.OPTICSTXTEMP}} C
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                            </v-flex>

                        </v-layout>
                      
                         <v-subheader style="background: #f0f0f0"> Bridge</v-subheader>

                        <v-list-tile v-if="serviceAccount.device&&serviceAccount.device.isU2000&&serviceAccount.deviceBridge">
                            <!-- <v-list-tile-action>
                                <v-chip style="height: 18px" class="white--text" color="light-green" v-if="serviceAccount.deviceBridge.isActive">Active</v-chip>
                                <v-chip style="height: 18px" class="white--text" color="red" v-else>Inactive</v-chip>
                            </v-list-tile-action> -->
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 12px" v-if="serviceAccount.deviceBridge.servicePortId">
                                    {{serviceAccount.deviceBridge.servicePortId}}
                                </v-list-tile-title>
                                <v-list-tile-title style="fontSize: 12px" v-else>
                                    {{serviceAccount.circuitNumber}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 12px">
                                    Outer vlan: {{serviceAccount.deviceBridge.vlanXlate}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 12px" v-if="serviceAccount.deviceBridge.vlan">
                                    Inner vlan: {{serviceAccount.deviceBridge.vlan}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="font-size: 12px" v-if="serviceAccount.deviceBridge.gemportId">Gemport: {{serviceAccount.deviceBridge.gemportId}}</v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 12px">
                                    Last Updated: {{formatDateTime(serviceAccount.deviceBridge.updatedAt)}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="fontSize: 12px">
                                <v-layout justify-center>
                                    <v-icon small style="height: 15px" color="light-green">arrow_drop_down</v-icon>
                                    {{serviceAccount.deviceBridge.downstreamRate}}
                                    <v-icon small style="height: 15px" color="red">arrow_drop_up</v-icon>
                                    {{serviceAccount.deviceBridge.upstreamRate}}
                                </v-layout>
                                <v-chip style="height: 18px" class="white--text" color="light-green" v-if="serviceAccount.deviceBridge.isActive">Active</v-chip>
                                <v-chip style="height: 18px" class="white--text" color="red" v-else>Inactive</v-chip>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile v-else-if="serviceAccount.device&&serviceAccount.device&&serviceAccount.device.deviceMakeModel.deviceMake.name.toLowerCase()=='zhone'&&serviceAccount.deviceBridge">
                            <!-- <v-list-tile-action>
                                
                            </v-list-tile-action> -->
                            <v-list-tile-content>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="serviceAccount.deviceBridge.vlan">
                                    Outer vlan: {{serviceAccount.deviceBridge.vlan}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="serviceAccount.deviceBridge.vlanXlate">
                                    Inner vlan: {{serviceAccount.deviceBridge.vlanXlate}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="serviceAccount.deviceBridge.tpType && tpTypeArray.find(x=>x.id == serviceAccount.deviceBridge.tpType)">
                                    TP Type: {{tpTypeArray.find(x=>x.id == serviceAccount.deviceBridge.tpType).name}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="serviceAccount.deviceBridge.rgMode && rgModeArray.find(x=>x.id == serviceAccount.deviceBridge.rgMode)">
                                    RG Mode: {{rgModeArray.find(x=>x.id == serviceAccount.deviceBridge.rgMode).name}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="font-size: 14px" v-if="serviceAccount.deviceBridge.gemportId">Port: {{serviceAccount.deviceBridge.tpIndex}}</v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 12px">
                                    Last Updated: {{formatDateTime(serviceAccount.deviceBridge.updatedAt)}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="fontSize: 12px">
                                <v-layout justify-center>
                                    <v-icon small style="height: 15px" color="light-green">arrow_drop_down</v-icon>
                                    {{serviceAccount.deviceBridge.downstreamRate}}
                                    <v-icon small style="height: 15px" color="red">arrow_drop_up</v-icon>
                                    {{serviceAccount.deviceBridge.upstreamRate}}
                                </v-layout>
                                <v-chip style="height: 18px" class="white--text" color="light-green" v-if="serviceAccount.deviceBridge.isActive">Active</v-chip>
                                <v-chip style="height: 18px" class="white--text" color="red" v-else>Inactive</v-chip>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-flex>

                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader two-line>
                        <v-subheader style="background: #f0f0f0">Change Requests <v-chip v-if="pendingRequests.length > 0">{{pendingRequests.length}}</v-chip>
                            <v-spacer></v-spacer>
                            <v-btn icon color="primary" v-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)" @click="changeRequestModal=true; noZhoneDeviceOnLocation=false; noAcsDeviceOnLocation=false;previousAccounts=false">
                                <v-icon color="white">add</v-icon>
                            </v-btn>
                        </v-subheader>
                        <v-tabs grow v-if="resolvedRequests.length>0">
                            <v-tab @click="showPendingRequests = true, showResolvedRequests = false">Pending</v-tab>
                            <v-tab @click="showPendingRequests = false, showResolvedRequests = true">Resolved</v-tab>
                        </v-tabs>
                        <v-list v-if="showPendingRequests" three-line>
                            <v-list-tile v-for="pending in pendingRequests" :key="pending.id">
                                <v-list-tile-content>
                                    <v-list-tile-title style="fontSize: 14px">
                                        {{pending.requestType}}<span style="font-size: 12px" v-if="pending.migrationLocation">: {{pending.migrationLocation.locationDescription}}</span>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="fontSize: 12px">
                                        <h4 class="grey--text font-weight-light">
                                            <b>Submitted:</b> {{ formatDate(pending.createdAt) }}
                                        </h4>
                                        <h4 class="grey--text font-weight-light">
                                            <b>Requested Date:</b> {{ formatDate(pending.requestedChangeDate) }}
                                        </h4>
                                    </v-list-tile-sub-title>
                                     <v-list-tile-sub-title style="fontSize: 12px" v-if="(pending.requestType.includes('Upgrade')||pending.requestType.includes('Downgrade'))&&pending.fromSpeedProfile&&pending.toSpeedProfile">
                                        
                                                From:
                                                <v-icon small color="light-green">arrow_drop_down</v-icon>
                                                {{pending.fromSpeedProfile.downloadMbps}}
                                                <v-icon small color="red">arrow_drop_up</v-icon>
                                                {{pending.fromSpeedProfile.uploadMbps}}
                                    </v-list-tile-sub-title>
                                     <v-list-tile-sub-title style="font-size: 12px" v-if="(pending.requestType.includes('Upgrade')||pending.requestType.includes('Downgrade'))&&pending.fromSpeedProfile&&pending.toSpeedProfile">
                                       To:
                                                <v-icon small color="light-green">arrow_drop_down</v-icon>
                                                {{pending.toSpeedProfile.downloadMbps}}
                                                <v-icon small color="red">arrow_drop_up</v-icon>
                                                {{pending.toSpeedProfile.uploadMbps}}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-layout justify-center>
                                        <v-progress-circular size="20" v-if="acceptingRequestChange" indeterminate color="primary"></v-progress-circular>
                                        <v-btn icon v-else-if="!denyingRequestChange" class="mx-1">
                                            <v-icon small color="light-green" @click="pending.requestType != 'Reactivation'? acceptRequestChange(pending):acceptReactivation(pending)">done</v-icon>
                                        </v-btn>

                                        <v-progress-circular v-if="denyingRequestChange" size="20" indeterminate color="primary"></v-progress-circular>
                                        <v-btn class="mx-1" icon v-else-if="!acceptingRequestChange">
                                            <v-icon small color="red" @click="denyRequestItem(pending)">clear</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-if="pendingRequests.length==0">
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    No Pending Requests
                                </v-list-tile-sub-title>
                            </v-list-tile>
                        </v-list>
                        <v-list v-else-if="showResolvedRequests" three-line>
                            <v-list-tile v-for="resolved in resolvedRequests" :key="resolved.id">
                                <v-list-tile-action>
                                    <v-chip style="height: 18px" class="white--text" dense v-if="resolved.status=='Resolved'" color="light-green">{{resolved.status}}</v-chip>
                                    <v-chip style="height: 18px" class="white--text" dense v-else color="red">{{resolved.status}}</v-chip>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title style="fontSize: 14px">
                                        {{resolved.requestType}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="fontSize: 12px" v-if="(resolved.requestType.includes('Upgrade')||resolved.requestType.includes('Downgrade'))&&resolved.fromSpeedProfile&&resolved.toSpeedProfile">
                                        
                                                From:
                                                <v-icon small color="light-green">arrow_drop_down</v-icon>
                                                {{resolved.fromSpeedProfile.downloadMbps}}
                                                <v-icon small color="red">arrow_drop_up</v-icon>
                                                {{resolved.fromSpeedProfile.uploadMbps}}
                                    </v-list-tile-sub-title>
                                     <v-list-tile-sub-title style="font-size: 12px" v-if="(resolved.requestType.includes('Upgrade')||resolved.requestType.includes('Downgrade'))&&resolved.fromSpeedProfile&&resolved.toSpeedProfile">
                                       To:
                                                <v-icon small color="light-green">arrow_drop_down</v-icon>
                                                {{resolved.toSpeedProfile.downloadMbps}}
                                                <v-icon small color="red">arrow_drop_up</v-icon>
                                                {{resolved.toSpeedProfile.uploadMbps}}
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title style="font-size: 12px">
                                        {{formatDate(resolved.updatedAt)}}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    {{resolved.fnoContactName}}
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-if="resolvedRequests.length==0">
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    No Resolved Requests
                                </v-list-tile-sub-title>
                            </v-list-tile>
                        </v-list>
                    </v-list>
                </v-flex>

                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader two-line>
                        <v-subheader style="background: #f0f0f0">Tickets <v-chip v-if="pendingTickets.length > 0">{{pendingTickets.length}}</v-chip>
                            <v-spacer></v-spacer>
                            <v-btn icon color="primary" @click="addTicket()">
                                <v-icon color="white">add</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" @click="getTickets()"><v-icon color="white">refresh</v-icon></v-btn>
                        </v-subheader>
                        <v-tabs grow v-if="resolvedTickets.length>0">
                            <v-tab @click="showPendingTickets = true, showResolvedTickets = false">Pending</v-tab>
                            <v-tab @click="showPendingTickets = false, showResolvedTickets = true">Resolved</v-tab>
                        </v-tabs>
                        <v-list v-if="showPendingTickets">
                            <v-list-tile v-for="pending in pendingTickets" :key="pending.id" @click="routeToTicketSummary(pending.id)">
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px" v-if="pending.name">
                                        {{pending.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-title style="font-size: 14px" v-else>
                                        <span v-if="pending.ticketCategory">{{pending.ticketCategory.name}} </span>
                                        <span v-else-if="pending.ticketCategoryItem&&pending.ticketCategoryItem.ticketCategory">{{pending.ticketCategoryItem.ticketCategory.name}}</span>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="font-size: 14px">{{pending.ticketCategoryItem ? pending.ticketCategoryItem.name : ''}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-chip style="height: 18px" :class="`${(pending.currentStatus||'').replace(/\s/g,'').toLowerCase()} white--text`">{{pending.currentStatus}}</v-chip>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-if="pendingTickets.length == 0">
                                <v-list-tile-sub-title style="font-size: 14px">
                                    No Pending Tickets.
                                </v-list-tile-sub-title>
                            </v-list-tile>
                        </v-list>
                        <v-list v-else-if="showResolvedTickets">
                            <v-list-tile v-for="resolved in resolvedTickets" :key="resolved.id" @click="routeToTicketSummary(resolved.id)">
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px" v-if="resolved.name">
                                        {{resolved.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-title style="font-size: 14px" v-else>
                                        <span v-if="resolved.ticketCategory">{{resolved.ticketCategory.name}} </span>
                                        <span v-else-if="resolved.ticketCategoryItem&&resolved.ticketCategoryItem.ticketCategory">{{resolved.ticketCategoryItem.ticketCategory.name}}</span>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="font-size: 14px">{{resolved.ticketCategoryItem ? resolved.ticketCategoryItem.name : ''}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-chip style="height: 18px" :class="`${(resolved.currentStatus||'').replace(/\s/g,'').toLowerCase()} white--text`">{{resolved.currentStatus}}</v-chip>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </v-list>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12 sm4 class="text-xs-left">

            <v-tabs grow v-model="commentTab">
                <v-tab>
                    <v-icon class="mx-1">chat</v-icon> Comments
                </v-tab>
                <v-tab>
                    <v-icon class="mx-1">timeline</v-icon>Timeline
                </v-tab>

            </v-tabs>
            <div v-if="commentTab == 0">
            <!-- <v-subheader style="background: #f0f0f0">Comments</v-subheader> -->
            <i style="font-size: 12px;" class="pl-3">These comments are for internal use only</i>
            <v-layout align-center justify-center wrap class="ma-2">
                <v-flex xs10>
                    <!-- <VueAtTextarea
      v-model="comment"
      @change="handleChange"
      :members="members"
    /> -->
                    <at-ta :members="members" v-model="comment">
                        <v-textarea auto-grow rows="2" outline></v-textarea>
                    </at-ta>
                </v-flex>
                <v-flex xs2 class="text-xs-left pl-3">
                    <v-btn icon @click="addServiceAccountComment(comment)">
                        <v-icon>send</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>

            <div style="overflow-y: auto; max-height: 50vh;">
                <v-layout v-for="item in commentArray" :key="item.id" justify-start align-center style="border-bottom: 1px solid lightgrey">
                    <v-flex xs3 class="text-xs-left ml-1">
                        <b>{{ item.commentedByName
                            }} {{ item.commentedBySurname}}</b>
                        <!-- <small>{{item.organisation.name}}</small>  -->
                        <br />
                        <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                    </v-flex>
                    <v-flex class="text-xs-left pa-2" xs8>

                        <span class="darkgrey--text text-xs-left" v-html="item.comment"></span>
                    </v-flex>
                </v-layout>
            </div>
            </div>
            <div v-else style="overflow-y: auto; max-height: 70vh; padding: 5px">
                  <v-timeline dense>
                    <v-timeline-item fill-dot v-for="(item, index) in allServiceAccountHistory" :icon="getIcon(item)" :color="item.colour?item.colour:'grey'" :key="index">
                        <v-card v-if="item.logType == 'Account'">
                            <v-card-text style="font-size: 12px">
                                <span v-html="item.circuitNumber"></span>
                                <br />
                                 <v-layout align-center justify-start style="fontSize: 12px">
                                        <v-icon style="height: 12px" color="light-green">arrow_drop_down</v-icon>
                                        {{item.packagesIsp.packagesFno.speedProfile.downloadMbps}}
                                        <v-icon style="height: 12px" color="red">arrow_drop_up</v-icon>
                                        {{item.packagesIsp.packagesFno.speedProfile.uploadMbps}}
                                    </v-layout>
                                     <v-chip color="red" style="height: 16px; font-size:12px" class="white--text" v-if="item.isSuspended">Account Suspended</v-chip>
                                    <br v-if="item.isSuspended" />
                                <span style="color: grey; font-size: 10px">{{ item.fnoActivationDate }} <span v-if="item.fnoDeactivationDate">- {{item.fnoDeactivationDate}}</span></span>
                            </v-card-text>
                        </v-card>
                        <v-card v-else-if="item.logType == 'Change'">
                            <v-card-text style="font-size: 12px">
                                 <span>{{item.requestType}} Request</span>
                                    <br />
                                    <span style="font-size: 11px" v-if="item.migrationLocation">Move services from <b>{{item.location.locationDescription}}</b> to <b>{{item.migrationLocation.locationDescription}}</b></span>
                                    <br v-if="item.migrationLocation" />
                                    <span style="font-size: 11px" v-if="item.requestedBy"><b>{{item.requestedBy.name +' ' +item.requestedBy.surname}}</b> requested the change for {{formatDate(item.requestedChangeDate)}}</span>
                                    <br v-if="item.requestedBy" />
                                    <span style="font-size: 11px" v-if="item.approvedBy"><b>{{item.approvedBy.name +' ' +item.approvedBy.surname}}</b> {{item.status == 'Resolved'?'approved':'rejected'}} the change on {{formatDate(item.dateResolved)}}</span>
                                    <span style="font-size: 11px" v-else-if="item.status=='Resolved'||item.status=='Denied'">Change {{item.status == 'Resolved'?'approved':'rejected'}} on {{item.dateResolved?formatDate(item.dateResolved):formatDateTime(item.updatedAt)}}</span>
                                    <br v-if="item.status == 'Denied'&&item.comment"/>
                                    <span style="font-size: 11px" v-if="item.status == 'Denied'&&item.comment">Reason: <i>{{item.comment}}</i></span>
                                    <br  v-if="item.status=='Resolved'||item.status=='Denied'"/>
                                    <!-- <v-layout align-center justify-start style="fontSize: 12px">
                                        <v-icon style="height: 12px" color="light-green">arrow_drop_down</v-icon>
                                        {{item.packagesIsp.packagesFno.speedProfile.downloadMbps}}
                                        <v-icon style="height: 12px" color="red">arrow_drop_up</v-icon>
                                        {{item.packagesIsp.packagesFno.speedProfile.uploadMbps}}
                                    </v-layout> -->
                                    <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                            </v-card-text>
                        </v-card>
                    </v-timeline-item>
                </v-timeline>
            </div>
        </v-flex>
    </v-layout>
  

    <!-- Add ticket Modal -->

    <v-dialog v-model="addTicketModal" width="1200px" persistent>
        <v-card>
            <TicketSummaryModal :ticket="ticketItem" @close="addTicketModal=false, ticketItem={}" @ticketCreated="addTicketModal=false,getTickets()" />
        </v-card>
    </v-dialog>

    <v-dialog v-model="changeRequestModal" persistent width="750px">
        <v-card flat color="white">
            <v-toolbar flat color="primary">
                <h3 class="title white--text">Log Change Request</h3>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="changeRequestModal=false,changeRequestItem={}">X</v-btn>
            </v-toolbar>
            <v-card-text pa-2>
                <v-container grid-list-xs>
                    <v-layout wrap>
                        <v-flex sm12 md12>
                            <v-autocomplete ref="requestType" v-on:blur="$refs['requestType'].blur()" clearable hide-no-data flat color="primary" :items="populateRequestTypes" v-model="changeRequestItem.requestType" label="Change Request Type"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm12 md12 v-if="changeRequestItem.requestType=='Upgrade'||changeRequestItem.requestType=='Downgrade'">
                            <v-text-field flat color="primary" v-model="serviceAccount.packagesIsp.name" label="From" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12 v-if="changeRequestItem.requestType=='Upgrade'||changeRequestItem.requestType=='Downgrade'">
                            <v-autocomplete ref="selectablePackages" v-on:blur="$refs['selectablePackages'].blur()" v-if="selectablePackages.length>0" clearable hide-no-data flat color="primary" return-object :items="selectablePackages" v-model="changeRequestItem.toPackage" item-value="id" label="*To">
                                <template v-slot:selection="data">{{ data.item.name }}</template>
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-tile-content>
                                            <v-list-tile-title class="grey--text font-weight-bold">{{data.item.name}} <span v-if="data.item.packagesFno.isGlobal">(Globally Available)</span></v-list-tile-title>
                                            <v-list-tile-sub-title>
                                                <v-layout align-center class="grey--text font-weight-light">
                                                    <v-icon color="light-green">arrow_drop_down</v-icon>
                                                    {{data.item.packagesFno.speedProfile.downloadMbps}}
                                                    <v-icon color="red">arrow_drop_up</v-icon>
                                                    {{data.item.packagesFno.speedProfile.uploadMbps}}
                                                </v-layout>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <span class="grey--text" v-else-if="changeRequestItem.requestType =='Upgrade'">No Upgradeable Packages available.</span>
                            <span class="grey--text" v-else-if="changeRequestItem.requestType =='Downgrade'">No Downgradeable Packages available.</span>
                        </v-flex>
                        <v-flex py-3 xs12 sm6 md6 v-if="changeRequestItem.requestType!==''&&changeRequestItem.requestType!==null&&changeRequestItem.requestType">
                            <h3 class="grey--text">Requested Change Date:</h3>
                        </v-flex>
                        <v-flex xs12 sm6 md6 v-if="changeRequestItem.requestType!==''&&changeRequestItem.requestType!==null&&changeRequestItem.requestType">
                            <v-menu :close-on-content-click="false">
                                <v-text-field :value="changeRequestItem.requestedChangeDate" slot="activator" label="Change Date" prepend-icon="date_range" read-only required></v-text-field>
                                <v-date-picker :min="today" v-model="changeRequestItem.requestedChangeDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex sm8 md8 v-if="changeRequestItem.requestType=='Migration'&&changeRequestItem.requestedChangeDate">
                            <v-autocomplete ref="filterNetwork" v-on:blur="$refs['filterNetwork'].blur()" v-model="filterNetwork" :items="networks" clearable item-text="name" item-value="id" label="Migration Location Network"></v-autocomplete>

                        </v-flex>
                        <v-flex sm4 md4 v-if="changeRequestItem.requestType=='Migration'&&changeRequestItem.requestedChangeDate&&filterNetwork">
                            <v-btn flat color="primary" @click="attachLocationModal=true">
                                <v-icon>add_circle_outline</v-icon>Attach Location
                            </v-btn>

                        </v-flex>
                        <v-flex sm12 md12 v-if="changeRequestItem.requestType=='Migration'&&filterNetwork&&changeRequestItem.migrationLocation">
                            <v-text-field label="Migration Location" v-model="changeRequestItem.migrationLocation.locationDescription" disabled></v-text-field>

                            <v-card v-if="previousAccounts">
                                <v-container grid-list-xs>
                                    <v-layout wrap>
                                        <v-flex xs12 sm12 md12 text-xs-left v-for="serviceAccount in previousAccountsList" :key="serviceAccount.id">
                                            <v-layout justify-center>
                                                <v-flex xs8 v-if="serviceAccount.serviceAccountIdentifier">
                                                    <h2 class="subheading grey--text font-weight-bold">Account Code:</h2>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <h3 class="grey--text font-weight-light">{{serviceAccount.serviceAccountIdentifier}}</h3>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout justify-center v-if="serviceAccount.initialActivation">
                                                <v-flex xs8>
                                                    <h2 class="subheading grey--text font-weight-bold">Initial Activation Date:</h2>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <h3 class="grey--text font-weight-light">
                                                        <v-chip small color="primary" class="white--text font-weight-bold">{{formatDate(serviceAccount.initialActivation)}}</v-chip>
                                                    </h3>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout justify-left>
                                                <v-flex xs8>
                                                    <h2 class="subheading grey--text font-weight-bold">Last Update:</h2>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <h3 class="grey--text font-weight-light">
                                                        <v-chip small color="primary" class="white--text font-weight-bold">{{formatDate(serviceAccount.createdAt)}}</v-chip>
                                                    </h3>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout justify-center v-if="serviceAccount.packagesIspId!==null">
                                                <v-flex xs8>
                                                    <h2 class="subheading grey--text font-weight-bold">Data Package:</h2>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <h3 class="grey--text font-weight-light">{{serviceAccount.packagesIsp.customerOrganisation.name}} | {{serviceAccount.packagesIsp.name}}</h3>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout justify-center v-if="serviceAccount.packagesIspId!==null">
                                                <v-flex xs8>
                                                    <h2 class="subheading grey--text font-weight-bold">Data Package Term:</h2>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <h3 class="grey--text font-weight-light">{{serviceAccount.packagesIsp.term}}</h3>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout v-if="serviceAccount.fnoDeactivationDate" justify-left>
                                                <v-flex xs8>
                                                    <h2 class="subheading grey--text font-weight-bold">FNO Deactivation:</h2>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <h3 class="grey--text font-weight-light">
                                                        <v-chip small color="primary" class="white--text font-weight-bold">{{formatDate(serviceAccount.fnoDeactivationDate)}}</v-chip>
                                                    </h3>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex xs12>
                                                    <v-checkbox label="Terminate" v-model="serviceAccount.terminate" @change="terminate(serviceAccount)"></v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                    </v-layout>
                                </v-container>

                            </v-card>
                        </v-flex>
                        <v-flex sm12 md12 v-if="previousAccounts">
                            <span class="grey--text">Other Service Accounts on Location</span>
                        </v-flex>
                        <v-flex sm12 md12 v-if="noZhoneDeviceOnLocation&&(serviceAccount.device.Handle_ID!==null&&serviceAccount.device.Handle_ID!==0)">
                            <span class="grey--text">No Zhone Device Installed on Location</span>
                        </v-flex>
                        <v-flex sm12 md12 v-if="noAcsDeviceOnLocation&&(serviceAccount.device.acsDevice===true)">
                            <span class="grey--text">No ACS Device Installed on Location</span>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn v-if="validateMigration()===true&&submit===true" color="primary" round class="white--text" @click="logServiceAccountChange(changeRequestItem)">Submit</v-btn>
                    <v-btn v-else disabled color="primary" round class="white--text">Submit</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="denyRequestModal" max-width="750px">
        <v-card>
            <v-toolbar flat class="primary">
                <h2 class="headline white--text">REASON FOR DENYING REQUEST:</h2>
            </v-toolbar>
            <v-layout justify-center>
                <v-flex xs10>
                    <v-textarea v-model="denyReason" label="Please provide a reason"></v-textarea>
                </v-flex>
            </v-layout>
            <v-card-actions class="justify-center layout px-0">
                <v-btn color="primary" round @click="denyRequestModal=false,denyReason=''">Cancel</v-btn>
                <v-btn v-if="denyReason!==''" color="primary" round @click="denyRequestChange(denyItem)">Submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="acceptReactivationRequest" max-width="750px">
        <v-card>
            <v-toolbar flat class="primary">
                <h2 class="headline white--text">Confirm device</h2>
                <v-spacer></v-spacer>
                <v-btn flat @click="changeRequestItem={},acceptReactivationRequest=false">X</v-btn>
            </v-toolbar>
            <v-layout justify-center>
                <v-flex xs10>
                    <v-radio-group v-model="changeRequestItem.device" column mandatory>
                        <v-radio v-for="template in locationDevices" :key="template.id" :label="`${template.deviceMakeModel.deviceMake.name} ${template.deviceMakeModel.name} | ${template.ponMac}`" :value="template"></v-radio>
                    </v-radio-group>
                </v-flex>
            </v-layout>
            <v-card-actions class="justify-center layout px-0">
                <v-btn v-if="changeRequestItem.device" color="primary" round @click="acceptRequestChange(changeRequestItem)">Submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="migrationErrorModal" width="500px" persistent>
        <v-card flat color="white">
            <v-toolbar flat color="primary">
                <h3 class="title white--text">Error Processing Request</h3>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center align-center wrap>
                    <v-flex xs10 mx-1>
                        <span class="grey--text">{{migrationErrorMessage}}</span>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center align-center>
                    <v-btn color="primary" round class="white--text" @click="migrationErrorMessage='', migrationErrorModal=false">Okay</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="suspendDialog" persistent max-width="750px">
        <v-card>
            <v-toolbar flat color="primary">
                <h3 class="title white--text">
                    SUSPEND
                </h3>
                <v-spacer></v-spacer>

                <v-btn flat color="white" class="white--text" @click="submitSuspend()">Submit</v-btn>

                <v-btn flat color="white" class="white--text" @click="(suspendDialog = false)">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center align-center>
                    <v-flex>
                        <v-menu>
                            <v-text-field :value="formatDate(this.suspendItem.dueDate)" slot="activator" label="Preferred Date" prepend-icon="date_range"></v-text-field>
                            <v-date-picker :min="todaySuspend" v-model="suspendItem.dueDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import configData from "../../../config/config.json";
import TicketSummaryModal from '../components/TicketSummaryModal.vue'
import At from "vue-at";
import AtTa from "vue-at/dist/vue-at-textarea"; // for textarea
import {
    VueAtTextarea
} from 'vue-at-textarea'
export default {
    components: {
        TicketSummaryModal,
        At,
        VueAtTextarea,
        AtTa
    },
    data() {
        return {
            acceptReactivationRequest: false,
            changeRequestItem: {},
            commentArray: [],
            comment: '',
            commentTab: 0,
            suspendDialog: false,
            suspendItem: {
                dueDate: ''
            },
            denyingRequestChange: false,
            acceptingRequestChange: false,
            populateRequestTypes: [],
            submit: true,
            online: false,
            terminatePreviousList: [],
            migrationLocationSet: false,
            previousAccountsList: [],
            pagination: {
                totalItems: 0
            },
            previousAccounts: false,
            deviceDetail: {},
            onuKey: 0,
            noAcsDeviceOnLocation: false,
            noZhoneDeviceOnLocation: false,
            filterNetwork: null,
            search: "",
            page: 1,
            locationLength: 0,
            filteredLocations: [],
            networks: [],
            attachLocationModal: false,
            showDownloadError: false,
            showUploadError: false,
            loader: null,
            config: null,
            keySpeed: 0,
            maxDownload: 0,
            maxUpload: 0,
            acsDevice: false,
            uploadSpeed: 0,
            downloadSpeed: 0,
            visibleDownload: false,
            visibleUpload: false,
            dateTimeSelect: false,
            addTemplate: false,
            addCommentBox: false,
            statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
            importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
            ticketItem: {},
            ticketCategories: [],
            ticketCategoryItems: [],
            filteredCategoryItems: [],
            filteredUsers: [],
            ticketAssignedLog: [],
            ticketCommentLog: [],
            filteredTickets: {},
            ticketTemplates: [],
            locationDevices: [],
            userRoles: [],
            addTicketModal: false,
            addWifiProfileItem: false,
            allOpenTickets: [],
            allPendingRequests: [],
            allIspPackages: [],
            allResolvedRequests: [],
            allResolvedTickets: [],
            allServiceAccountHistory: [],
            availableFrequency: [],
            changeRequestItem: {},
            changeRequestModal: false,
            denyItem: {},
            denyReason: '',
            denyRequestModal: false,
            migrationErrorMessage: '',
            migrationErrorModal: false,
            encryptionTypes: ["WEP", "WPA", "WPA2", "WPA+WPA2"],
            errorSnackbar: false,
            internetServices: [],
            members: [],
            membersEmail: [],
            pendingRequests: [],
            pendingTickets: [],
            pendingRequestPage: 1,
            pendingTicketPage: 1,
            resolvedRequests: [],
            resolvedTickets: [],
            resolvedRequestPage: 1,
            resolvedTicketPage: 1,
            selectablePackages: [],
            serviceAccount: null,
            serviceAccountHistory: [],
            serviceAccountHistoryPage: 1,
            showInternet: true,
            showWifi: false,
            showVoip: false,
            showPendingRequests: true,
            showResolvedRequests: false,
            showPendingTickets: true,
            showResolvedTickets: false,
            snackbar: false,
            text: '',
            today: new Date().toISOString().substr(0, 10),
            top: "y",
            wifiItem: {},
            wifiServices: [],
            voipServices: [],
            rgModeArray: [{
                    id: 1,
                    name: 'Routed'
                },
                {
                    id: 2,
                    name: 'BRouted'
                },
                {
                    id: 3,
                    name: 'rPPPoE'
                },
                {
                    id: 4,
                    name: 'bPPPoE'
                },
                {
                    id: 5,
                    name: 'Bridged'
                },
                {
                    id: 6,
                    name: 'Not Applicable'
                }

            ],
            tpTypeArray: [{
                    id: 1,
                    name: 'Ethernet UNI'
                },
                {
                    id: 2,
                    name: 'VCC Termination Point'
                },
                {
                    id: 3,
                    name: 'Mapper Service Profile'
                },
                {
                    id: 4,
                    name: 'IP Host Config Data'
                },
                {
                    id: 5,
                    name: 'GEM Interworking Termination Point'
                },
                {
                    id: 6,
                    name: 'Multicast GEM Interworking Termination Point'
                },
                {
                    id: 7,
                    name: 'xDSL UNI'
                },
                {
                    id: 8,
                    name: 'VDSL UNI'
                },
                {
                    id: 9,
                    name: 'Ether Flow Termination Point'
                },
                {
                    id: 10,
                    name: 'Physical Path UNI'
                },
                {
                    id: 11,
                    name: 'Physical Path RF Video UNI'
                },
                {
                    id: 12,
                    name: 'Physical Path IPTV UNI'
                },
                {
                    id: 13,
                    name: 'H248 Voice'
                },
                {
                    id: 14,
                    name: 'SIP Voice'
                },
                {
                    id: 15,
                    name: 'SIP PLAR Voice'
                },
                {
                    id: 16,
                    name: 'PWE Termination'
                },
                {
                    id: 17,
                    name: 'Virtual Ethernet'
                },
                {
                    id: 18,
                    name: 'dot11 Termination Point'
                },
                {
                    id: 19,
                    name: 'Fiber LAN Termination Point'
                },
                {
                    id: 20,
                    name: 'TR69 Termination Point'
                },
                {
                    id: 21,
                    name: 'Management Termination Point'
                },
                {
                    id: 22,
                    name: 'MGCP Voice Termination Point'
                }
            ],
        };
    },
    watch: {
        "$route.params.serviceAccountId": {
            immediate: true,
            async handler(value) {
                if (value) {
                    this.initialize()
                }
            }
        },

        "changeRequestItem.requestType": {
            immediate: true,
            handler(value) {
                if (value == "Upgrade") {
                    this.selectablePackages = this.allIspPackages.filter(x => {
                        return (
                            (x.locationNetworkId ===
                                this.serviceAccount.location.locationNetworkId ||
                                x.packagesFno.isGlobal) &&
                            x.packagesFno.speedProfile.downloadMbps >=
                            this.serviceAccount.packagesIsp.packagesFno.speedProfile
                            .downloadMbps ||
                            x.packagesFno.speedProfile.uploadMbps >
                            this.serviceAccount.packagesIsp.packagesFno.speedProfile
                            .uploadMbps
                        );
                    });
                } else if (value == "Downgrade") {
                    this.selectablePackages = this.allIspPackages.filter(x => {
                        return (
                            (x.locationNetworkId ===
                                this.serviceAccount.location.locationNetworkId ||
                                x.packagesFno.isGlobal) &&
                            x.packagesFno.speedProfile.downloadMbps <=
                            this.serviceAccount.packagesIsp.packagesFno.speedProfile
                            .downloadMbps ||
                            x.packagesFno.speedProfile.uploadMbps <
                            this.serviceAccount.packagesIsp.packagesFno.speedProfile
                            .uploadMbps
                        );
                    });
                }
            }
        },
        page(value) {
            this.pagination.page = this.page;
            if (value && value != "" && value != this.$route.query.records) {
                if (this.$route.query.search) {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            offset: (value - 1) * this.$route.query.records,
                            records: this.$route.query.records,
                            search: this.$route.query.search
                        }
                    });
                } else {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            offset: (value - 1) * this.$route.query.records,
                            records: this.$route.query.records
                        }
                    });
                }
            }
        },
        filterNetwork(value) {
            if (value !== null && typeof value !== "undefined") {
                Api()
                    .get('/Locations/byNetwork/' + value + '/activeFilter').then(response => {
                        this.filteredLocations = response.data.result
                        this.locationLength = response.data.count
                        this.pagination.totalItems = this.locationLength
                        //this.attachLocationModal=true
                    })

            }
        },
        '$route.query.search': {
            immediate: true,
            handler(value) {
                if (this.$route.query.search && value !== "" && value != null && this.filterNetwork) {
                    Api()
                        .get('/Locations/byNetwork/' + this.filterNetwork + '/activeFilter', {
                            params: {
                                search: value,
                                offset: '0',
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.filteredLocations = response.data.result
                            this.locationLength = response.data.count
                            this.pagination.totalItems = this.locationLength
                        })
                } else if (this.$route.query.offset && this.filterNetwork) {
                    Api()
                        .get('/Locations/byNetwork/' + this.filterNetwork + '/activeFilter', {
                            params: {
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.filteredLocations = response.data.result
                            this.locationLength = response.data.count
                            this.pagination.totalItems = this.locationLength
                        })

                }
            }
        },
        '$route.query.offset': {
            immediate: true,
            handler(value) {
                this.loading = true
                if (value !== "" && value != null && this.$route.query.search && this.$route.query.search != "" && this.$route.query.search !== null) {

                    Api()
                        .get('/Locations/byNetwork/' + this.filterNetwork + '/activeFilter', {
                            params: {
                                search: this.$route.query.search,
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.filteredLocations = response.data.result
                            this.locationLength = response.data.count
                            this.pagination.totalItems = this.locationLength
                        })
                } else if (value !== "" && value != null) {
                    Api()
                        .get('/Locations/byNetwork/' + this.filterNetwork + '/activeFilter', {
                            params: {
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.filteredLocations = response.data.result
                            this.locationLength = response.data.count
                            this.pagination.totalItems = this.locationLength
                        })
                }
            }
        },
        "migrationLocationSet": {
            immediate: true,
            handler(value) {
                if (value === true) {
                    if (this.changeRequestItem.requestType === 'Migration' && this.changeRequestItem.migrationLocation) {

                        if (this.serviceAccount.device.acsDevice === true) {
                            Api().get('/devices/acs/byLocation/' + this.changeRequestItem.migrationLocation.id).then(response => {

                                if (response.data.length > 0) {
                                    this.noAcsDeviceOnLocation = false

                                    Api().get('/serviceAccounts/active/byLocation/' + this.changeRequestItem.migrationLocation.id).then(response => {

                                        this.previousAccountsList = response.data
                                        this.previousAccountsList.map(x => x.terminate = false)
                                        if (response.data.length > 0) {
                                            for (let k = 0; k < response.data.length; k++) {
                                                let endDate = new Date(response.data[k].fnoDeactivationDate)
                                                let requestDate = new Date(this.changeRequestItem.requestedChangeDate)
                                                if (endDate > requestDate || response.data[k].fnoDeactivationDate === null) {
                                                    this.previousAccounts = true
                                                    return false
                                                } else {
                                                    this.previousAccounts = false
                                                    return true
                                                }
                                            }
                                        } else {
                                            this.previousAccounts = false
                                            return true
                                        }
                                    })
                                } else {
                                    this.noAcsDeviceOnLocation = true

                                    Api().get('/serviceAccounts/active/byLocation/' + this.changeRequestItem.migrationLocation.id).then(response => {
                                        this.previousAccountsList = response.data
                                        this.previousAccountsList.map(x => x.terminate = false)
                                        if (response.data.length > 0) {
                                            for (let k = 0; k < response.data.length; k++) {
                                                let endDate = new Date(response.data[k].fnoDeactivationDate)
                                                let requestDate = new Date(this.changeRequestItem.requestedChangeDate)
                                                if (endDate > requestDate || response.data[k].fnoDeactivationDate === null) {
                                                    this.previousAccounts = true
                                                    return false
                                                } else {
                                                    this.previousAccounts = false
                                                    return false
                                                }
                                            }
                                        } else {
                                            this.previousAccounts = false
                                            return false
                                        }
                                    })
                                }

                            })
                        } else if (this.serviceAccount.device.Handle_ID !== 0 && this.serviceAccount.device.Handle_ID !== null) {
                            Api().get('/devices/zhone/byLocation/' + this.changeRequestItem.migrationLocation.id).then(response => {

                                if (response.data.length > 0) {
                                    this.noZhoneDeviceOnLocation = false

                                    Api().get('/serviceAccounts/active/byLocation/' + this.changeRequestItem.migrationLocation.id).then(response => {

                                        this.previousAccountsList = response.data
                                        this.previousAccountsList.map(x => x.terminate = false)
                                        if (response.data.length > 0) {
                                            for (let k = 0; k < response.data.length; k++) {
                                                let endDate = new Date(response.data[k].fnoDeactivationDate)
                                                let requestDate = new Date(this.changeRequestItem.requestedChangeDate)
                                                if (endDate > requestDate || response.data[k].fnoDeactivationDate === null) {
                                                    this.previousAccounts = true
                                                    return false
                                                } else {
                                                    this.previousAccounts = false
                                                    return true
                                                }
                                            }
                                        } else {
                                            this.previousAccounts = false
                                            return true
                                        }
                                    })
                                } else {
                                    this.noZhoneDeviceOnLocation = true

                                    Api().get('/serviceAccounts/active/byLocation/' + this.changeRequestItem.migrationLocation.id).then(response => {
                                        this.previousAccountsList = response.data
                                        this.previousAccountsList.map(x => x.terminate = false)
                                        if (response.data.length > 0) {
                                            for (let k = 0; k < response.data.length; k++) {
                                                let endDate = new Date(response.data[k].fnoDeactivationDate)
                                                let requestDate = new Date(this.changeRequestItem.requestedChangeDate)
                                                if (endDate > requestDate || response.data[k].fnoDeactivationDate === null) {
                                                    this.previousAccounts = true
                                                    return false
                                                } else {
                                                    this.previousAccounts = false
                                                    return false
                                                }
                                            }
                                        } else {
                                            this.previousAccounts = false
                                            return false
                                        }
                                    })
                                }

                            })
                        }

                    } else {
                        return true
                    }

                    this.migrationLocationSet = false
                }
            }
        },
    },
    async created() {
        this.initialize()
    },
    methods: {
        async initialize() {
            this.config = configData;
            await this.getServiceAccountDetails();
            this.fetchServiceAccountComments()
            this.getChangeRequests();
            this.getServiceAccountHistory();
            this.getActiveISPPackages();
            this.getTickets()
            this.fetchOrgContacts();
            this.fetchNetworks()
            this.$router.push({
                name: this.$route.name,
                query: {
                    offset: "0",
                    records: "10"
                }
            });
        },
        handleChange(data) {
            console.log(data)
        },
        acceptReactivation(item) {
            this.changeRequestItem = item
            this.acceptReactivationRequest = true
        },
        redirectToDevice(id) {
            this.$router.push({
                path: "/devices/" + id,
            });
        },
        deviceStatus(ponMac) {
            Api()
                .get("/acs/deviceDetail/" + ponMac)
                .then(response => {
                    let online = response.data.message.uptime > 0 ? true : false
                    if (online === true) {
                        this.online = true
                    }
                })
        },
        async addServiceAccountComment(comment) {
            let notify = []
            for (let i = 0; i < this.members.length; i++) {
                if (comment.includes(this.members[i])) {
                    let find = this.membersEmail.find(x => x.fullname == this.members[i])
                    notify.push(find)
                }
            }
            console.log(notify)
            // if
            Api()
                .post("/serviceAccountComment", {
                    notify: notify,
                    isInternal: true,
                    serviceAccountId: parseInt(this.$route.params.serviceAccountId),
                    type: "comment",
                    commentedById: this.$store.state.user.id,
                    comment: comment,
                })
                .then((response) => {
                    // if (this.internal == false) {
                    //     this.notifyIsp();
                    //     this.notifyFno();
                    // } else {
                    //     this.notifyFno();
                    // }
                    this.fetchServiceAccountComments();
                    this.comment = "";
                });
        },
        formatMobileNumber(number){
            let result = ''
            for(let i=0;i<number.length;i++){
                // if(i<(number.length-4)){
                //     result += '*'
                // } else {
                    result += number[i]
                // }
            }
            return result
        },
        fetchServiceAccountComments() {
            Api().get('/serviceAccountComment/' + this.$route.params.serviceAccountId).then(res => {
                this.commentArray = res.data.map((x) =>
                    ({
                        organisation: x.organisation,
                        commentedById: x.commentedById,
                        commentedByName: x.commentedBy.name,
                        commentedBySurname: x.commentedBy.surname,
                        comment: x.comment,
                        type: x.type,
                        createdAt: x.createdAt,
                        isInternal: x.isInternal,
                        id: x.id,
                        commentLogType: true,
                    })
                )
                 this.commentArray.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            })
        },
        async terminate(serviceAccount) {
            if (serviceAccount.terminate === true) {
                this.submit = true
                let obj = {
                    status: "Pending",
                    serviceAccountId: serviceAccount.id,
                    serviceAccountIdentifier: serviceAccount.serviceAccountIdentifier,
                    locationId: serviceAccount.locationId,
                    migrationLocationId: serviceAccount.migrationLocationId || null,
                    packagesIspId: serviceAccount.packagesIspId,
                    locationDescription: serviceAccount.location.locationDescription,
                    customerOrganisationId: serviceAccount.packagesIsp
                        .customerOrganisationId,
                    ispName: serviceAccount.customerOrganisation.name,
                    requestType: 'Termination',
                    isChange: serviceAccount.isChange,
                    ispNotification: true,
                    fnoNotification: true,
                    ispContactName: null,
                    fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
                    fromSpeedProfileName: serviceAccount.packagesIsp.packagesFno.speedProfile
                        .downloadMbps +
                        "/" +
                        serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
                    fromSpeedProfileId: serviceAccount.packagesIsp.packagesFno
                        .speedProfileId,
                    authenticationType: serviceAccount.authenticationType,
                    pppoeUsername: serviceAccount.pppoeUsername || null,
                    pppoePassword: serviceAccount.pppoePassword || null,
                    IPoEMacAddress: serviceAccount.IPoEMacAddress || null,
                    initialActivation: serviceAccount.initialActivation ?
                        new Date(serviceAccount.initialActivation)
                        .toISOString()
                        .substr(0, 10) : null,
                    fnoActivationDate: serviceAccount.fnoActivationDate ?
                        new Date(serviceAccount.fnoActivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    fnoDeactivationDate: serviceAccount.fnoDeactivationDate ?
                        new Date(serviceAccount.fnoDeactivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    ispActivationDate: serviceAccount.ispActivationDate ?
                        new Date(serviceAccount.ispActivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    ispDeactivationDate: serviceAccount.ispDeactivationDate ?
                        new Date(serviceAccount.ispDeactivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    requestedChangeDate: this.changeRequestItem.requestedChangeDate,
                    staticIpv4: serviceAccount.staticIpv4 || null,
                    staticIpv6: serviceAccount.staticIpv6 || null,
                    deviceId: serviceAccount.deviceId,
                    device: serviceAccount.device,
                    deviceBridge: serviceAccount.deviceBridge || null,
                    deviceBridgeId: serviceAccount.deviceBridgeId,
                    isDeleted: false,
                    isActive: true
                }
                let same = false
                await this.terminatePreviousList.map(x => {
                    if (x.serviceAccountId === obj.serviceAccountId) {
                        same = true
                    }
                })
                if (same === false) {
                    this.terminatePreviousList.push(obj)

                }

            } else if (serviceAccount.terminate === false) {
                let index = this.terminatePreviousList.findIndex(x => x.serviceAccountId === serviceAccount.id);

                this.terminatePreviousList.splice(index, 1)
                console.log(this.terminatePreviousList)
                this.submit = false
            }

        },
        getIcon(obj) {
            if(obj.logType == 'Account'){
                    return 'miscellaneous_services'

            } else {
                switch (obj.status) {
                case 'Resolved':
                    return 'check'
                case 'Denied':
                    return 'close'
                case 'Pending':
                    return 'pending'
            }
            }
            
        },
        validateMigration() {
            if (this.changeRequestItem.requestType === 'Migration') {
                if (this.changeRequestItem.requestedChangeDate && this.changeRequestItem.migrationLocation) {
                    if (this.serviceAccount.device.Handle_ID !== null && this.serviceAccount.device.Handle_ID !== 0) {
                        if (this.noZhoneDeviceOnLocation === false) {
                            if (this.previousAccountsList.length !== this.terminatePreviousList.length) {
                                return false
                            } else {
                                return true
                            }

                        } else {
                            return false
                        }
                    }
                    if (this.serviceAccount.device.acsDevice === true) {
                        if (this.noAcsDeviceOnLocation === false) {
                            if (this.previousAccountsList.length !== this.terminatePreviousList.length) {
                                return false
                            } else {
                                return true
                            }
                        } else {
                            return false
                        }
                    }
                } else {
                    return false
                }
            } else {
                if (this.changeRequestItem.requestedChangeDate) {
                    return true
                } else {
                    return false
                }
            }

        },
        attachLocation(location) {
            this.changeRequestItem.migrationLocation = location
            this.migrationLocationSet = true
            this.attachLocationModal = false
        },
        fetchNetworks() {
            Api()
                .get("/locationNetworks")
                .then(response => {
                    this.networks = response.data;
                });
        },
        clearTemplate() {
            this.ticketItem.dueDate = "";
            this.ticketItem.dueTime = "";
            this.ticketItem.assignedToId = null;
            this.ticketItem.ticketCategoryItemId = null;
            this.ticketItem.ticketCategoryId = null;
        },
        populateTemplate() {
            this.clearTemplate();
            for (let i = 0; i < this.ticketTemplates.length; i++) {
                if (this.ticketTemplates[i].id === this.ticketItem.ticketTemplateId) {
                    this.ticketItem.dueDate = this.ticketTemplates[i].dueDate;
                    this.ticketItem.dueTime = this.ticketTemplates[i].dueTime;
                    this.ticketItem.assignedToId = this.ticketTemplates[i].contactId;
                    if (this.ticketTemplates[i].ticketCategoryItem !== null) {
                        this.ticketItem.ticketCategoryItemId = this.ticketTemplates[
                            i
                        ].ticketCategoryItemId;
                        this.ticketItem.ticketCategoryId = this.ticketTemplates[
                            i
                        ].ticketCategoryItem.ticketCategoryId;
                    }
                }
            }
        },
        fetchUserRoles() {
            Api()
                .get('/userRole')
                .then(response => {
                    this.userRoles = response.data
                })
        },
        addTicket() {
            this.ticketItem = {
                currentStatus: 'Pending',
                importance: 'Average',
                dueDate: new Date(),
                serviceAccountId: this.serviceAccount.id,
                locationId: this.serviceAccount.locationId,
                location: this.serviceAccount.location,
                customerOrganisationId: this.serviceAccount.customerOrganisationId,
                shareWithIsp: true,
                documents: []
            }
            this.addTicketModal = true;

        },
        fetchOrgContacts() {
            this.filteredUsers = [];
            Api()
                .get("/organisationContact")
                .then(async response => {
                    this.filteredUsers = response.data.filter(function (el) {
                        return el.userType !== "endClient";
                    });
                    let contactArray = this.filteredUsers.map(x => x.contact);
                    this.members = contactArray.map((x) =>
                        x.name + " " + x.surname
                    )
                    this.membersEmail = contactArray.map((x) => ({
                        id: x.id,
                        fullname: x.name + " " + x.surname,
                        emailAddress: x.emailAddress,
                    }))
                    this.filteredUsers = contactArray;
                });
        },
        addComment(comment) {
            this.ticketCommentLog.push({
                commentedBy: this.$store.state.user,
                commentedById: this.$store.state.user.id,
                comment: comment,
                type: "comment",
                createdAt: new Date()
            });
            this.comment = "";
            this.addCommentBox = false;
        },
        fetchTicketTemplates() {
            Api()
                .get("/ticketTemplate")
                .then(response => {
                    this.ticketTemplates = response.data;
                });
        },
        async routeToTicketSummary(item) {
            this.$router.push({
                path: "/ticketSummary/" + item
            });
        },
        routeToServiceAccount() {
            this.$router.push({
                path: "/serviceAccounts"
            });
        },
        routeToIsp(id) {
            this.$router.push({
                path: "/ispList/"+id
            });
        },
        async goToLocation() {
            this.$router.push({
                path: "/locationNetworks/" +
                    this.serviceAccount.location.locationNetworkId +
                    "/" +
                    this.serviceAccount.locationId,
            });
        },
        async suspendServices(item) {
            if (this.authAdmin(this.$store.state.currentRoute)) {
                this.suspendDialog = true
                this.suspendItem = item
            }
        },
        async submitSuspend() {
            let obj = {
                serviceAccountId: this.suspendItem.id,
                locationId: this.suspendItem.locationId,
                circuitNumber: this.suspendItem.circuitNumber,
                device: this.suspendItem.device,
                deviceBridgeId: this.suspendItem.deviceBridgeId,
                deviceBridge: this.suspendItem.deviceBridge,
                type: 'U2000',
                organisationId: this.$store.state.currentOrg.org.id,
                customerOrganisationId: this.suspendItem.supplierOrganisationId,
                dueDate: this.suspendItem.dueDate
            }
            await Api().post('/serviceAccounts/suspendServices/' + this.suspendItem.id, obj).then(res => {
                this.getServiceAccountDetails()
                this.getTickets()
                this.suspendDialog = false
            })
        },
        async reactivateServices(item) {
            if (this.authAdmin(this.$store.state.currentRoute)) {
                let obj = {
                    serviceAccountId: item.id,
                    locationId: item.locationId,
                    circuitNumber: item.circuitNumber,
                    device: item.device,
                    deviceBridgeId: item.deviceBridgeId,
                    deviceBridge: item.deviceBridge,
                    type: 'U2000',
                    organisationId: this.$store.state.currentOrg.org.id,
                    customerOrganisationId: item.supplierOrganisationId
                }
                await Api().post('/serviceAccounts/reactivateServices/' + item.id, obj).then(res => {
                    this.getServiceAccountDetails()
                    this.getTickets()
                })
            }
        },
        denyRequestItem(item) {
            if (this.authUpdate(this.$store.state.currentRoute)) {

                this.denyItem = Object.assign({}, item);
                this.denyRequestModal = true;
            }
        },
        async getActiveISPPackages() {
            await Api()
                .get(
                    "/supplier/packagesIsps/networkCustomer/active/" +
                    this.serviceAccount.location.locationNetworkId +
                    "/" +
                    this.serviceAccount.customerOrganisationId
                )
                .then(response => {
                    this.allIspPackages = response.data;
                });
        },
        getU2000OnuStatus(obj) {
            Api().get('/u2000/ontStatus', {
                params: {
                    deviceName: obj.upstreamDevice.systemName,
                    frameId: obj.frame,
                    slotId: obj.slot,
                    portId: obj.port,
                    onuId: obj.ponId
                }
            }).then(res => {
                this.deviceDetail.status = {
                    isOnline: res.data.data.RUNSTAT == 'Up' ? true : false,
                    uptime: new Date(res.data.data.LSTUPTIME),
                    lastDowntime: res.data.data.LSTDOWNTIME && res.data.data.LSTDOWNTIME != '--' ? new Date(res.data.data.LSTDOWNTIME) : null,
                    lastDownCause: res.data.data.LSTDOWNCAUSE
                }
                this.onuKey += 1
            })
        },

        getU2000OnuDetails(obj) {
            Api().get('/u2000/ontDDM', {
                params: {
                    deviceName: obj.upstreamDevice.systemName,
                    frameId: obj.frame,
                    slotId: obj.slot,
                    portId: obj.port,
                    onuId: obj.ponId
                }
            }).then(res => {
                this.deviceDetail.details = res.data.data
                this.onuKey += 1
            })
        },
        async getServiceAccountDetails() {
            await Api()
                .get("/serviceAccounts/supplier/" + this.$route.params.serviceAccountId)
                .then(async response => {
                    this.serviceAccount = response.data;
                    if (response.data.deviceBridge) {
                        this.internetServices = [response.data.deviceBridge]
                    }
                    this.locationDevices = await this.fetchLocationDevices(this.serviceAccount.locationId)
                    if (response.data.device.isU2000) {
                        // this.populateRequestTypes = ['Upgrade','Downgrade','Migration', 'Termination']
                        this.populateRequestTypes = ['Upgrade', 'Downgrade', 'Termination']
                    } else {
                        this.populateRequestTypes = ['Upgrade', 'Downgrade', 'Termination']
                    }
                    this.maxDownload = response.data.packagesIsp.packagesFno.speedProfile.downloadMbps + 0.5 * response.data.packagesIsp.packagesFno.speedProfile.downloadMbps
                    this.maxUpload = response.data.packagesIsp.packagesFno.speedProfile.uploadMbps + 0.5 * response.data.packagesIsp.packagesFno.speedProfile.uploadMbps
                    if (this.serviceAccount.device.isU2000) {
                        //  this.deviceStatus(this.serviceAccount.device.ponMac)
                        this.getU2000OnuStatus(this.serviceAccount.device)
                        this.getU2000OnuDetails(this.serviceAccount.device)
                    }
                    // Non-Zhone/Huawei ONTs (e.g. Jackal Creek BDCOM): status kept current by DeviceSync_NMS every 5 minutes.
                    const dev = this.serviceAccount.device
                    if (dev && !dev.isU2000 && !(dev.Handle_ID > 0) && dev.isOnline !== null && dev.isOnline !== undefined) {
                        this.deviceDetail = { status: { isOnline: !!dev.isOnline, checkedAt: dev.lastOnlineUpdate } }
                        this.onuKey++
                    }
                    if (this.serviceAccount.device.Handle_ID !== null && this.serviceAccount.device.Handle_ID > 0) {
                        this.deviceDetail.complete = true
                        this.getOnuStatus(this.serviceAccount.device.Handle_ID);
                    }

                });
        },
        getOnuStatus(handleId) {
            this.deviceDetail.initiated = true
            Api().get('/zhone/onuStatus/' + handleId)
                .then(response => {
                    if (response.data.code == 200) {
                        this.deviceDetail.status = {
                            isOnline: ((response.data.data.onuStatusWord == '00000000000000000000001') || response.data.data.onuStatusWord == '01000000000000000000001') ? true : false,
                            opticRssi: parseFloat(response.data.data.opticRssi) / 10,
                            rxPower: parseFloat(response.data.data.rxPower) / 10,
                        }
                    } else {
                        this.deviceDetail.status = {
                            isOnline: false,
                            opticRssi: parseFloat(response.data.data.opticRssi) / 10,
                            rxPower: parseFloat(response.data.data.rxPower) / 10
                        }
                    }
                    this.onuKey++
                })
        },
        async getServiceAccountHistory() {
            await Api()
                .get(
                    "/serviceAccounts/history/allByIdentifier/" +
                    this.serviceAccount.serviceAccountIdentifier
                )
                .then(response => {
                    this.allServiceAccountHistory = response.data
                    console.log(this.allServiceAccountHistory)
                    // this.serviceAccountHistory = this.allServiceAccountHistory.slice(0, 2);
                });
        },
        async getChangeRequests() {
            await Api()
                .get(
                    "/serviceAccountsAuditLog/byServiceAccountId/" +
                    this.$route.params.serviceAccountId
                )
                .then(response => {
                    this.allPendingRequests = response.data.filter(
                        x => x.status != "Denied" && x.status != "Resolved" && x.status != "Canceled"
                    );
                    this.pendingRequests = this.allPendingRequests.slice(0, 1);

                    this.allResolvedRequests = response.data.filter(
                        x => x.status == "Denied" || x.status == "Resolved" || x.status == "Canceled"
                    );
                    this.resolvedRequests = this.allResolvedRequests.slice(0, 1);
                });
        },
        async getTickets() {
            await Api().get('/ticket/byServiceAccount/' + this.$route.params.serviceAccountId)
                .then(response => {
                    this.allOpenTickets = response.data.filter(x => !x.isComplete)
                    this.allResolvedTickets = response.data.filter(x => x.isComplete)
                    this.pendingTickets = this.allOpenTickets.slice(0, 1);
                    this.resolvedTickets = this.allResolvedTickets.slice(0, 1);
                })
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd");
            } else {
                null;
            }
        },
        formatDateTime(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd HH:MM");
            } else {
                null;
            }
        },
        terminatePreviousAccounts() {
            for (let k = 0; k < this.terminatePreviousList.length; k++) {
                Api().post('/serviceAccountsAuditLog', this.terminatePreviousList[k])
                    .then(async response => {
                        this.terminatePreviousList[k].serviceAccountAuditLogId = response.data.id;
                        this.terminatePreviousList[k].ponMac = this.terminatePreviousList[k].device.ponMac
                        this.terminatePreviousList[k].autoProvision = true;
                        if (this.terminatePreviousList[k].device.acsDevice === true) {
                            this.terminatePreviousList[k].autoProvisionType = "ACS";
                            this.terminatePreviousList[k].status = "Resolved",
                                Api().put('/serviceAccountsAuditLog/' + response.data.id, this.terminatePreviousList[k])
                        } else if (this.terminatePreviousList[k].device.Handle_ID !== 0 && this.terminatePreviousList[k].device.Handle_ID !== null) {
                            this.terminatePreviousList[k].autoProvisionType = "Zhone";
                            this.terminatePreviousList[k].status = "Resolved",
                                this.terminatePreviousList[k].connectionId = this.terminatePreviousList[k].device.Handle_ID
                            Api().put('/serviceAccountsAuditLog/' + response.data.id, this.terminatePreviousList[k])
                        }
                        // TODO: Should there not be a U2000 Option??

                    });
            }

        },
        terminateCurrentCreateNew() {
            let obj = {
                status: "Pending",
                serviceAccountId: this.$route.params.serviceAccountId,
                serviceAccountIdentifier: this.serviceAccount.serviceAccountIdentifier,
                locationId: this.serviceAccount.locationId,
                migrationLocationId: this.changeRequestItem.migrationLocation.id || null,
                packagesIspId: this.serviceAccount.packagesIspId,
                locationDescription: this.serviceAccount.location.locationDescription,
                customerOrganisationId: this.serviceAccount.packagesIsp
                    .customerOrganisationId,
                ispName: this.serviceAccount.customerOrganisation.name,
                requestType: "Migration",
                isChange: this.serviceAccount.isChange,
                ispNotification: true,
                fnoNotification: true,
                ispContactName: null,
                fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
                fromSpeedProfileName: this.serviceAccount.packagesIsp.packagesFno.speedProfile
                    .downloadMbps +
                    "/" +
                    this.serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
                fromSpeedProfileId: this.serviceAccount.packagesIsp.packagesFno
                    .speedProfileId,
                authenticationType: this.serviceAccount.authenticationType,
                pppoeUsername: this.serviceAccount.pppoeUsername || null,
                pppoePassword: this.serviceAccount.pppoePassword || null,
                IPoEMacAddress: this.serviceAccount.IPoEMacAddress || null,
                initialActivation: this.serviceAccount.initialActivation ?
                    new Date(this.serviceAccount.initialActivation)
                    .toISOString()
                    .substr(0, 10) : null,
                fnoActivationDate: this.serviceAccount.fnoActivationDate ?
                    new Date(this.serviceAccount.fnoActivationDate)
                    .toISOString()
                    .substr(0, 10) : null,
                fnoDeactivationDate: this.serviceAccount.fnoDeactivationDate ?
                    new Date(this.serviceAccount.fnoDeactivationDate)
                    .toISOString()
                    .substr(0, 10) : null,
                ispActivationDate: this.serviceAccount.ispActivationDate ?
                    new Date(this.serviceAccount.ispActivationDate)
                    .toISOString()
                    .substr(0, 10) : null,
                ispDeactivationDate: this.serviceAccount.ispDeactivationDate ?
                    new Date(this.serviceAccount.ispDeactivationDate)
                    .toISOString()
                    .substr(0, 10) : null,
                requestedChangeDate: this.changeRequestItem.requestedChangeDate,
                staticIpv4: this.serviceAccount.staticIpv4 || null,
                staticIpv6: this.serviceAccount.staticIpv6 || null,
                deviceId: this.serviceAccount.deviceId,
                deviceBridgeId: this.serviceAccount.deviceBridgeId,
                isDeleted: false,
                isActive: true
            }
            if (this.serviceAccount.deviceBridgeId) {
                Api().get('/deviceBridge/byBridge/' + this.serviceAccount.deviceBridgeId).then(response => {
                    obj.vlan = response.data[0].vlan,
                        obj.port_1 = response.data[0].port_1,
                        obj.port_2 = response.data[0].port_2,
                        obj.port_3 = response.data[0].port_3,
                        obj.port_4 = response.data[0].port_4,
                        obj.downstreamRate = response.data[0].downstreamRate,
                        obj.upstreamRate = response.data[0].upstreamRate
                })

            }
            Api().post('/serviceAccountsAuditLog', obj)
                .then(async response => {
                    obj.serviceAccountAuditLogId = response.data.id;
                    obj.ponMac = this.serviceAccount.device.ponMac
                    obj.autoProvision = true;

                    obj.status = "Resolved",
                        obj.deviceId = this.serviceAccount.device.id,
                        obj.accessType = this.serviceAccount.authenticationType,
                        obj.username = this.serviceAccount.pppoeUsername,
                        obj.password = this.serviceAccount.pppoePassword,
                        obj.customerOrganisationId = this.serviceAccount.customerOrganisationId,
                        obj.username = this.serviceAccount.pppoeUsername,

                        obj.ipv4or6 = 'ipv4'
                    obj.serviceAccountId = this.serviceAccount.id
                    obj.locationId = this.serviceAccount.locationId,
                        obj.serviceAccountIdentifier = this.serviceAccount.serviceAccountIdentifier,
                        obj.migrationLocationId = this.changeRequestItem.migrationLocation.id,
                        obj.packagesIspId = this.serviceAccount.packagesIspId,
                        obj.locationDescription = this.serviceAccount.location.locationDescription,
                        // customerOrganisationId: this.serviceAccount.packagesIsp.customerOrganisationId,
                        obj.ispName = this.serviceAccount.customerOrganisation.name,
                        //obj.serviceAccount.requestType: item.requestType,
                        obj.isChange = this.serviceAccount.isChange,
                        obj.ispNotification = true,
                        obj.fnoNotification = true,
                        obj.ispContactName = null,
                        obj.fnoContactName =
                        this.$store.state.user.name + " " + this.$store.state.user.surname,
                        obj.fromSpeedProfileName =
                        this.serviceAccount.packagesIsp.packagesFno.speedProfile
                        .downloadMbps +
                        "/" +
                        this.serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
                        obj.fromSpeedProfileId = this.serviceAccount.packagesIsp.packagesFno
                        .speedProfileId,
                        obj.IPoEMacAddress = this.serviceAccount.IPoEMacAddress || null,
                        obj.initialActivation = this.serviceAccount.initialActivation ?
                        new Date(this.serviceAccount.initialActivation)
                        .toISOString()
                        .substr(0, 10) :
                        null,
                        obj.fnoActivationDate = this.serviceAccount.fnoActivationDate ?
                        new Date(this.serviceAccount.fnoActivationDate)
                        .toISOString()
                        .substr(0, 10) :
                        null,
                        obj.fnoDeactivationDate = this.serviceAccount.fnoDeactivationDate ?
                        new Date(this.serviceAccount.fnoDeactivationDate)
                        .toISOString()
                        .substr(0, 10) :
                        null,
                        obj.ispActivationDate = this.serviceAccount.ispActivationDate ?
                        new Date(this.serviceAccount.ispActivationDate)
                        .toISOString()
                        .substr(0, 10) :
                        null,
                        obj.ispDeactivationDate = this.serviceAccount.ispDeactivationDate ?
                        new Date(this.serviceAccount.ispDeactivationDate)
                        .toISOString()
                        .substr(0, 10) :
                        null,
                        obj.staticIpv4 = this.serviceAccount.staticIpv4 || null,
                        obj.staticIpv6 = this.serviceAccount.staticIpv6 || null,
                        obj.deviceBridgeId = this.serviceAccount.deviceBridgeId,
                        obj.isDeleted = false,
                        obj.isActive = true
                    if (this.serviceAccount.device.Handle_ID !== null && this.serviceAccount.device.Handle_ID !== 0) {
                        obj.autoProvisionType = "Zhone";
                        obj.connectionId = this.serviceAccount.device.Handle_ID
                    } else if (this.serviceAccount.device.acsDevice) {
                        obj.autoProvisionType = "ACS"
                    }
                    Api().put('/serviceAccountsAuditLog/' + response.data.id, obj).then(response => {

                        this.getChangeRequests()
                        this.getTickets()
                        this.changeRequestModal = false;
                    })
                });
        },
        logServiceAccountChange(item) {
            let toSpeedId = null;
            let toSpeedName = null;
            let toPackageId = null;
            let uploadMbps = 0
            let downloadMbps = 0

            if (item.requestType === "Migration") {
                this.terminatePreviousAccounts()
                this.terminateCurrentCreateNew()
            }
            if (
                item.requestType !== "Termination" &&
                item.requestType !== "Migration" &&
                item.toPackage
            ) {
                toSpeedId = item.toPackage.packagesFno.speedProfileId;
                toSpeedName =
                    item.toPackage.packagesFno.speedProfile.downloadMbps +
                    "/" +
                    item.toPackage.packagesFno.speedProfile.uploadMbps;
                toPackageId = item.toPackage.id;
                uploadMbps = item.toPackage.packagesFno.speedProfile.uploadMbps
                downloadMbps = item.toPackage.packagesFno.speedProfile.downloadMbps
            }
            if (
                item.requestType !== "Migration"
            ) {
                let obj = {
                    status: "Pending",
                    serviceAccountId: this.$route.params.serviceAccountId,
                    serviceAccountIdentifier: this.serviceAccount.serviceAccountIdentifier,
                    locationId: this.serviceAccount.locationId,
                    migrationLocationId: this.migrationLocationId || null,
                    packagesIspId: this.serviceAccount.packagesIspId,
                    locationDescription: this.serviceAccount.location.locationDescription,
                    customerOrganisationId: this.serviceAccount.packagesIsp
                        .customerOrganisationId,
                    ispName: this.serviceAccount.customerOrganisation.name,
                    requestType: item.requestType,
                    isChange: this.serviceAccount.isChange,
                    ispNotification: true,
                    fnoNotification: true,
                    ispContactName: null,
                    fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
                    fromSpeedProfileName: this.serviceAccount.packagesIsp.packagesFno.speedProfile
                        .downloadMbps +
                        "/" +
                        this.serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
                    fromSpeedProfileId: this.serviceAccount.packagesIsp.packagesFno
                        .speedProfileId,
                    toSpeedProfileId: toSpeedId,
                    toSpeedProfileName: toSpeedName,
                    toPackageId: toPackageId,
                    oldServiceAccountId: this.serviceAccount.id,
                    authenticationType: this.serviceAccount.authenticationType,
                    pppoeUsername: this.serviceAccount.pppoeUsername || null,
                    pppoePassword: this.serviceAccount.pppoePassword || null,
                    IPoEMacAddress: this.serviceAccount.IPoEMacAddress || null,
                    initialActivation: this.serviceAccount.initialActivation ?
                        new Date(this.serviceAccount.initialActivation)
                        .toISOString()
                        .substr(0, 10) : null,
                    fnoActivationDate: this.serviceAccount.fnoActivationDate ?
                        new Date(this.serviceAccount.fnoActivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    fnoDeactivationDate: this.serviceAccount.fnoDeactivationDate ?
                        new Date(this.serviceAccount.fnoDeactivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    ispActivationDate: this.serviceAccount.ispActivationDate ?
                        new Date(this.serviceAccount.ispActivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    ispDeactivationDate: this.serviceAccount.ispDeactivationDate ?
                        new Date(this.serviceAccount.ispDeactivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    requestedChangeDate: item.requestedChangeDate,
                    staticIpv4: this.serviceAccount.staticIpv4 || null,
                    staticIpv6: this.serviceAccount.staticIpv6 || null,
                    deviceId: this.serviceAccount.deviceId,
                    deviceBridgeId: this.serviceAccount.deviceBridgeId,
                    deviceBridge: this.serviceAccount.deviceBridge,
                    device: this.serviceAccount.device,
                    isDeleted: false,
                    isActive: true,
                    uploadMbps: uploadMbps,
                    downloadMbps: downloadMbps
                };
                Api()
                    .post("/serviceAccountsAuditLog", obj)
                    .then(async response => {
                        obj.serviceAccountAuditLogId = response.data.id;
                        await this.acceptFNOChange(obj);
                        this.changeRequestModal = false;
                        this.changeRequestItem = {};
                    });
            }
        },
        async acceptFNOChange(item) {
            let newServiceAccountId = null;
            if (this.authUpdate(this.$store.state.currentRoute)) {
                if (item.requestType !== "Termination") {
                    let locationId = null;
                    let deviceId = null;
                    if (item.requestType !== "Migration") {
                        locationId = item.locationId;
                        deviceId = item.deviceId;
                    } else {
                        locationId = item.migrationLocationId;
                        deviceId = null;
                    }
                    let requestedChangeDate = new Date(item.requestedChangeDate)
                    requestedChangeDate.setDate(requestedChangeDate.getDate() - 1)
                    Api().put("/serviceAccounts/" + this.$route.params.serviceAccountId, {
                        ispDeactivationDate: requestedChangeDate,
                        fnoDeactivationDate: requestedChangeDate
                    });
                    if (
                        item.authenticationType === "PPPoE" ||
                        item.authenticationType === "PPPOE"
                    ) {
                        item.IPoEActive = null;
                    } else {
                        item.IPoEActive = true;
                    }

                    let newAccount = {
                        serviceAccountIdentifier: item.serviceAccountIdentifier.toString(),
                        authenticationType: item.authenticationType,
                        pppoeUsername: item.pppoeUsername || null,
                        pppoePassword: item.pppoePassword || null,
                        IPoEMacAddress: item.IPoEMacAddress,
                        initialActivation: item.initialActivation,
                        fnoActivationDate: item.requestedChangeDate || null,
                        fnoDeactivationDate: null,
                        ispActivationDate: item.requestedChangeDate || null,
                        ispDeactivationDate: null,
                        staticIpv4: item.staticIpv4 || null,
                        staticIpv6: item.staticIpv6 || null,
                        isChange: true,
                        locationId: locationId,
                        deviceId: deviceId,
                        packagesIspId: item.toPackageId || item.packagesIspId,
                        // vlanId: item.vlan.id,
                        customerOrganisationId: item.customerOrganisationId,
                        supplierOrganisationId: this.serviceAccount.supplierOrganisationId,
                        organisationId: this.serviceAccount.organisationId,
                        circuitNumber: this.serviceAccount.circuitNumber,
                        deviceBridgeId: item.deviceBridgeId,
                        deviceBridge: item.deviceBridge ? item.deviceBridge : null,
                        innerVlan: this.serviceAccount.innerVlan,
                        outerVlan: this.serviceAccount.outerVlan,
                        contactId: this.serviceAccount.contactId,
                        IPoEActive: item.IPoEActive,
                        isDeleted: false,
                        isActive: true
                    }

                    await Api()
                        .post("/serviceAccounts", newAccount)
                        .then(response => {
                            newServiceAccountId = response.data.id;
                        });
                } else {
                    Api().put("/serviceaccounts/" + this.$route.params.serviceAccountId, {
                        fnoDeactivationDate: item.requestedChangeDate,
                        ispDeactivationDate: item.requestedChangeDate
                    });
                }

                let uploadMbps = 0;
                let downloadMbps = 0;
                if (item.uploadMbps) {
                    uploadMbps = item.uploadMbps
                }
                if (item.downloadMbps) {
                    downloadMbps = item.downloadMbps
                }
                if (item.toPackage && item.toPackage != null) {
                    uploadMbps = item.toPackage.packagesFno.speedProfile.uploadMbps;
                    downloadMbps = item.toPackage.packagesFno.speedProfile.downloadMbps;
                }
                let autoProvision = false;
                let autoProvisionType = null;
                let autoConfigure = false
                let autoConfigureType = null
                if (
                    this.serviceAccount.device &&
                    this.serviceAccount.device != null &&
                    this.serviceAccount.device.Handle_ID != null &&
                    !this.serviceAccount.device.isU2000
                ) {
                    autoProvision = true;
                    autoConfigure = true
                    autoProvisionType = "Zhone";
                    // autoConfigureType = 'Zhone'
                } else if (this.serviceAccount.device &&
                    this.serviceAccount.device != null &&
                    this.serviceAccount.device.isU2000) {
                    autoProvision = true;
                    autoProvisionType = "U2000";
                }
                if (
                    this.serviceAccount.device &&
                    this.serviceAccount.device != null &&
                    this.serviceAccount.device.acsDevice
                ) {
                    autoConfigure = true
                    autoConfigureType = 'ACS'
                } else if (this.serviceAccount.authenticationType != 'Bridged') {
                    autoConfigure = true
                }
                // debugger
                Api()
                    .put("/serviceAccountsAuditLog/" + item.serviceAccountAuditLogId, {
                        autoConfigure: autoConfigure,
                        autoConfigureType: autoConfigureType,
                        autoProvision: autoProvision,
                        autoProvisionType: autoProvisionType,
                        ponMac: this.serviceAccount.device.ponMac,
                        customerOrganisationId: item.customerOrganisationId,
                        fnoContactName: this.$store.state.user.name +
                            " " +
                            this.$store.state.user.surname,
                        requestedChangeDate: item.requestedChangeDate,
                        deviceId: item.deviceId,
                        device: item.device,
                        requestType: item.requestType,
                        oldServiceAccountId: item.oldServiceAccountId,
                        serviceAccountId: newServiceAccountId || this.serviceAccount.id,
                        serviceAccount: this.serviceAccount,
                        locationId: this.serviceAccount.locationId,
                        connectionId: item.deviceBridge ? item.deviceBridge.connectionId : null,
                        bridgeLogicalId: item.deviceBridge ? item.deviceBridge.bridgeLogicalId : null,
                        deviceBridgeId: item.deviceBridgeId,
                        deviceBridge: item.deviceBridge ? item.deviceBridge : null,
                        deviceConfiguration: item.deviceConfiguration ? item.deviceConfiguration : null,
                        uploadMbps: uploadMbps,
                        downloadMbps: downloadMbps,
                        isActive: false,
                        status: "Resolved",
                        dateResolved: new Date()
                    })
                    .then(response => {
                        this.snackbar = true
                        this.text = "Successfully completed change request!"
                        if (newServiceAccountId) {
                            this.$router.push({
                                path: "/serviceAccounts/" + newServiceAccountId
                            });
                        } else {
                            this.getChangeRequests()
                            this.getTickets()
                        }
                    });
            }
        },
        async fetchLocationDevices(id) {
            let result = []
            await Api().get('/devices/byLocation/' + id).then(res => {
                result = res.data.filter(x => x.deviceMakeModel&&x.deviceMakeModel.deviceTypeId == 1)
            })
            return result
        },
        async fetchDeviceBridges(id) {
            let result = []
            await Api().get('/deviceBridge/' + id).then(res => {
                result = res.data
            })
            return result
        },
        async validateMigrationDetails(item) {
            let locationDevices = await this.fetchLocationDevices(item.migrationLocationId)
            if (locationDevices.length == 1 && locationDevices[0].deviceMakeModel.deviceMakeId === this.serviceAccount.device.deviceMakeModel.deviceMakeId) {
                // handle one device: perfect match with make
                item.deviceId = locationDevices[0].id
                item.locationId = item.migrationLocationId
                let deviceBridges = await this.fetchDeviceBridges(item.deviceId)
                if (deviceBridges.length == 0) {
                    this.migrationErrorMessage = "No connections are currently listed against this device. Please ensure that the device has been configured before processing this request."
                    this.migrationErrorModal = true
                } else {
                    // let find = await deviceBridges.find(x=>x.vlanXlate === this.serviceAccount.deviceBridge.vlanXlate)
                    if (this.serviceAccount.deviceBridge) {
                        item.deviceBridgeId = this.serviceAccount.deviceBridgeId
                        this.processRequestChange(item)
                        let obj = {
                            description: 'Migrate services from ' + this.serviceAccount.device.ponMac + ' to ' + locationDevices[0].ponMac,
                            ticketCategoryItemId: 56,
                            currentStatus: 'Pending',
                            importance: 'Average',
                            dueDate: (new Date(item.requestedChangeDate) > new Date()) ? new Date(item.requestedChangeDate) : new Date(),
                            locationId: item.locationId,
                            deviceId: item.deviceId,
                            isActive: true,
                            isDeleted: false
                        }
                        this.createConfigurationTicket(obj)
                    } else {
                        this.migrationErrorMessage = "Required VLAN not found on configured connections. Please add it before processing this request."
                        this.migrationErrorModal = true
                    }

                }

            } else if (locationDevices.length > 1) {
                // handle multiple devices
                this.migrationErrorMessage = "Multiple ONU's listed at new location. Please rectify before processing request."
                this.migrationErrorModal = true
            } else if (locationDevices.length == 1) {
                // Handle one device: makes don't match
                item.deviceId = locationDevices[0].id
                item.locationId = item.migrationLocationId
                this.processRequestChange(item)
                let obj = {
                    description: 'Migrate services from ' + this.serviceAccount.device.ponMac + ' to ' + locationDevices[0].ponMac,
                    ticketCategoryItemId: 56,
                    currentStatus: 'Pending',
                    importance: 'Average',
                    dueDate: (new Date(item.requestedChangeDate) > new Date()) ? new Date(item.requestedChangeDate) : new Date(),
                    locationId: item.locationId,
                    deviceId: item.deviceId,
                    isActive: true,
                    isDeleted: false
                }
                this.createConfigurationTicket(obj)
            } else {
                // Handle no devices
                this.migrationErrorMessage = "No ONU's listed at new location. Please rectify before processing request."
                this.migrationErrorModal = true
            }
            this.acceptingRequestChange = false
        },

        async createConfigurationTicket(obj) {
            await Api().post("/ticket", obj).then(res => {
                this.snackbar = true
                this.text = "Successfully processed change request!"
            })
        },

        async acceptRequestChange(item) {
            if (item.requestType === "Termination") {
                // A termination runs at once if its date has passed, and removes the service from the ONT.
                const newer = (this.allPendingRequests || []).concat(this.allResolvedRequests || []).filter(x =>
                    x.id !== item.id && x.requestType !== "Termination" && x.status !== "Canceled" && x.status !== "Denied" &&
                    new Date(x.createdAt) > new Date(item.createdAt));
                const daysPast = (Date.now() - new Date(item.requestedChangeDate).getTime()) / 86400000;
                let warning = "";
                if (newer.length) warning += "There is a newer " + newer[0].requestType + " request on this account (" + new Date(newer[0].createdAt).toLocaleDateString("en-ZA") + "). ";
                if (daysPast > 7) warning += "This termination was due on " + new Date(item.requestedChangeDate).toLocaleDateString("en-ZA") + ", so it will run immediately. ";
                if (warning && !confirm(warning + "Approving it will remove the service from the ONT. Continue?")) return;
            }
            if (this.authUpdate(this.$store.state.currentRoute)) {
                this.acceptingRequestChange = true
                if (item.requestType !== "Termination") {
                    if (item.requestType === "Migration") {
                        await this.validateMigrationDetails(item)
                    } else {
                        this.processRequestChange(item)
                    }

                } else {
                    this.processRequestChange(item)
                    //  await Api().put("/serviceaccounts/" + item.serviceAccountId, {
                    //     fnoDeactivationDate: item.requestedChangeDate,
                    //     ispDeactivationDate: item.requestedChangeDate
                    //   }).then(res=>{

                    //   });
                }

            }
        },

        async processRequestChange(item) {
            let newServiceAccountId = this.serviceAccount.id;
            let requestedChangeDate = new Date(item.requestedChangeDate)
            requestedChangeDate.setDate(requestedChangeDate.getDate() - 1)
            if (item.authenticationType === "PPPoE") {
                item.IPoEActive = null;
            } else {
                item.IPoEActive = true;
            }
            // let packagesIspId = null;
            // if (item.toSpeedProfileId === null) {
            //   packagesIspId = item.packagesIspId;
            // } else {
            //   packagesIspId = item.toPackageId;
            // }
            if (item.requestType !== "Termination") {
                await Api().post("/serviceAccounts", {
                    serviceAccountIdentifier: item.serviceAccountIdentifier.toString(),
                    authenticationType: item.authenticationType || this.serviceAccount.authenticationType,
                    pppoeUsername: item.pppoeUsername || null,
                    pppoePassword: item.pppoePassword || null,
                    IPoEMacAddress: item.IPoEMacAddress,
                    initialActivation: item.initialActivation,
                    fnoActivationDate: item.requestedChangeDate || null,
                    fnoDeactivationDate: null,
                    ispActivationDate: item.requestedChangeDate || null,
                    ispDeactivationDate: null,
                    staticIpv4: item.staticIpv4 || null,
                    staticIpv6: item.staticIpv6 || null,
                    isChange: true,
                    locationId: item.locationId,
                    customerOrganisationId: item.customerOrganisationId,
                    supplierOrganisationId: this.serviceAccount.supplierOrganisationId,
                    circuitNumber: item.requestType != "Migration" ? this.serviceAccount.circuitNumber : null,
                    organisationId: this.serviceAccount.organisationId,
                    deviceBridgeId: item.requestType !== "Reactivation" ? this.serviceAccount.deviceBridgeId : null,
                    innerVlan: this.serviceAccount.innerVlan,
                    outerVlan: this.serviceAccount.outerVlan,
                    contactId: this.serviceAccount.contactId,
                    deviceId: item.deviceId,
                    packagesIspId: item.toPackageId || item.packagesIspId,
                    IPoEActive: item.IPoEActive,
                    isDeleted: false,
                    isActive: true
                }).then(response => {
                    newServiceAccountId = response.data.id
                });
            }
            // Close the old account only now that the new one exists: if creating it fails, the customer is left untouched.
            await Api().put("/serviceAccounts/" + item.serviceAccountId, {
                ispDeactivationDate: requestedChangeDate,
                fnoDeactivationDate: requestedChangeDate
            });

            let autoProvision = false;
            let autoProvisionType = null;
            let autoConfigure = false
            let autoConfigureType = null
            if (
                this.serviceAccount.device &&
                this.serviceAccount.device != null &&
                this.serviceAccount.device.Handle_ID != null &&
                !this.serviceAccount.device.isU2000
            ) {
                autoProvision = true;
                autoConfigure = true
                autoProvisionType = "Zhone";
                // autoConfigureType = 'Zhone'
            } else if (this.serviceAccount.device &&
                this.serviceAccount.device != null &&
                this.serviceAccount.device.isU2000) {
                autoProvision = true;
                autoProvisionType = "U2000";
            }
            if (
                this.serviceAccount.device &&
                this.serviceAccount.device != null &&
                this.serviceAccount.device.acsDevice
            ) {
                autoConfigure = true
                autoConfigureType = 'ACS'
            } else if (this.serviceAccount.authenticationType != 'Bridged') {
                autoConfigure = true
            }

            let uploadMbps = 0
            let downloadMbps = 0
            if (item.toSpeedProfile && item.toSpeedProfile != null) {
                uploadMbps = item.toSpeedProfile.uploadMbps
                downloadMbps = item.toSpeedProfile.downloadMbps
            }
            if (item.requestType !== "Reactivation") {
                Api()
                    .put("/serviceAccountsAuditLog/" + item.id, {
                        autoConfigure: autoConfigure,
                        autoConfigureType: autoConfigureType,
                        autoProvision: autoProvision,
                        autoProvisionType: autoProvisionType,
                        ponMac: this.serviceAccount.device.ponMac,
                        customerOrganisationId: item.customerOrganisationId,
                        fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
                        requestedChangeDate: item.requestedChangeDate,
                        deviceId: this.serviceAccount.deviceId,
                        requestType: item.requestType,
                        oldServiceAccountId: item.oldServiceAccountId,
                        serviceAccountId: newServiceAccountId || this.$route.params.serviceAccountId,
                        serviceAccount: this.serviceAccount,
                        locationId: this.serviceAccount.locationId,
                        connectionId: this.serviceAccount.deviceBridge ? this.serviceAccount.deviceBridge.connectionId : null,
                        bridgeLogicalId: this.serviceAccount.deviceBridge ? this.serviceAccount.deviceBridge.bridgeLogicalId : null,
                        deviceBridgeId: this.serviceAccount.deviceBridgeId,
                        deviceBridge: this.serviceAccount.deviceBridge,
                        deviceConfiguration: this.serviceAccount.deviceConfiguration,
                        device: this.serviceAccount.device,
                        uploadMbps: uploadMbps,
                        downloadMbps: downloadMbps,
                        isActive: false,
                        status: "Resolved",
                        dateResolved: new Date()
                    }).then(() => {

                        this.snackbar = true
                        this.text = "Successfully completed change request!"
                        if (newServiceAccountId != this.$route.params.serviceAccountId) {
                            this.$router.push({
                                path: "/serviceAccounts/" + newServiceAccountId
                            });
                        } else {
                            this.getChangeRequests()
                            this.getTickets()
                        }

                    });
            } else {
                let provisionTemplate = item.organisationBridgeTemplate
                provisionTemplate.downloadSpeed = item.fromSpeedProfile.downloadMbps
                provisionTemplate.uploadSpeed = item.fromSpeedProfile.uploadMbps
                Api()
                    .put("/serviceAccountsAuditLog/" + item.id, {
                        autoConfigure: autoConfigure,
                        autoConfigureType: autoConfigureType,
                        autoProvision: autoProvision,
                        autoProvisionType: autoProvisionType,
                        provisionTemplate: provisionTemplate,
                        ponMac: this.serviceAccount.device.ponMac,
                        device: item.device,
                        customerOrganisationId: item.customerOrganisationId,
                        fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
                        requestedChangeDate: item.requestedChangeDate,
                        deviceId: this.serviceAccount.deviceId,
                        requestType: item.requestType,
                        oldServiceAccountId: item.oldServiceAccountId,
                        serviceAccountId: newServiceAccountId || this.$route.params.serviceAccountId,
                        serviceAccount: this.serviceAccount,
                        locationId: this.serviceAccount.locationId,
                        connectionId: this.serviceAccount.deviceBridge ? this.serviceAccount.deviceBridge.connectionId : null,
                        bridgeLogicalId: this.serviceAccount.deviceBridge ? this.serviceAccount.deviceBridge.bridgeLogicalId : null,
                        deviceBridgeId: this.serviceAccount.deviceBridgeId,
                        deviceBridge: this.serviceAccount.deviceBridge,
                        deviceConfiguration: this.serviceAccount.deviceConfiguration,
                        device: this.serviceAccount.device,
                        uploadMbps: uploadMbps,
                        downloadMbps: downloadMbps,
                        isActive: false,
                        status: "Resolved",
                        dateResolved: new Date()
                    }).then(() => {

                        this.snackbar = true
                        this.text = "Successfully completed change request!"
                        if (newServiceAccountId != this.$route.params.serviceAccountId) {
                            this.$router.push({
                                path: "/serviceAccounts/" + newServiceAccountId
                            });
                        } else {
                            this.getChangeRequests()
                            this.getTickets()
                        }

                    });
            }

            this.acceptingRequestChange = false
        },
        denyRequestChange(item) {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                this.denyingRequestChange = true
                Api()
                    .put("/serviceAccountsAuditLog/" + item.id, {
                        serviceAccountId: this.$route.params.serviceAccountId,
                        fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
                        comment: this.denyReason,
                        isActive: false,
                        customerOrganisationId: item.customerOrganisationId,
                        status: "Denied"
                    })
                    .then(() => {
                        this.getChangeRequests()
                        this.denyRequestModal = false
                        this.denyingRequestChange = false
                        this.denyReason = ''
                    });
            }
        },
        async saveWifiProfile() {
            if (this.wifiItem.type === "ADD") {
                await Api()
                    .post("/acs/createWifi", {
                        ssid: this.wifiItem.ssid,
                        password: this.wifiItem.password,
                        channel: this.wifiItem.channel,
                        encryption: this.wifiItem.encryption,
                        enable: this.wifiItem.enable,
                        hidden: this.wifiItem.hidden,
                        frequency: this.wifiItem.frequencyBand,
                        ponMac: this.serviceAccount.device.ponMac,
                        customerOrganisationId: this.wifiItem.customerOrganisationId
                    })
                    .then(async response => {
                        if (response.data.code === 200) {
                            await Api()
                                .post("/deviceWifi", {
                                    ssid: this.wifiItem.ssid,
                                    password: this.wifiItem.password,
                                    channel: this.wifiItem.channel,
                                    encryption: this.wifiItem.encryption,
                                    enable: this.wifiItem.enable,
                                    hidden: this.wifiItem.hidden,
                                    frequencyBand: this.wifiItem.frequencyBand,
                                    deviceId: this.serviceAccount.deviceId,
                                    deviceBridgeId: this.serviceAccount.deviceBridgeId,
                                    customerOrganisationId: this.wifiItem.customerOrganisationId,
                                    isActive: true,
                                    isDeleted: false
                                })
                                .then(response => {
                                    this.wifiServices.push(response.data);
                                    this.snackbar = true
                                    this.text = response.data.message
                                });
                        } else {
                            this.errorSnackbar = true
                            this.text = response.data.message
                        }
                        this.wifiItem = {};
                        this.addWifiProfileItem = false;
                        let index = this.availableFrequency.find(x => x == this.wifiItem.frequency)
                        this.availableFrequency.splice(index, 1)
                    });
            } else if (this.item.type === "EDIT") {
                await Api()
                    .post("/acs/updateWifi", {
                        ssid: this.wifiItem.ssid,
                        password: this.wifiItem.password,
                        channel: this.wifiItem.channel,
                        encryption: this.wifiItem.encryption,
                        enable: this.wifiItem.enable,
                        hidden: this.wifiItem.hidden,
                        frequency: this.wifiItem.frequencyBand,
                        ponMac: this.device.ponMac,
                        customerOrganisationId: this.item.customerOrganisationId
                    }).then(response => {
                        Api()
                            .put("/deviceWifi/" + this.wifiItem.id, {
                                ssid: this.wifiItem.ssid,
                                password: this.wifiItem.password,
                                channel: this.wifiItem.channel,
                                encryption: this.wifiItem.encryption,
                                enable: this.wifiItem.enable,
                                hidden: this.wifiItem.hidden,
                                frequencyBand: this.wifiItem.frequencyBand,
                                isActive: true,
                                isDeleted: false
                            })
                            .then(async response => {
                                let find = await this.item.deviceWifis.find(x => x.id === this.wifiItem.id)
                                if (find) {
                                    let index = this.item.deviceWifis.indexOf(find)
                                    this.item.deviceWifis[index] = response.data
                                }
                                this.wifiItem = {};
                                this.wifiKey += 1
                                this.addWifiProfileItem = false;
                            });
                    })

            }
        },
    }
};
</script>

<style scoped>
.card-outter {
    position: relative;
    padding-bottom: 50px;
}

.card-actions {
    position: absolute;
    bottom: 0;
    align-content: "center";
    justify-content: "center";
}

v-list-tile-title {
    font-size: 14px
}

v-list-tile-sub-title {
    font-size: 14px
}
</style>
